!function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.Popper = t()
}(this, (function() {
    "use strict";
    function e(e) {
        return e && "[object Function]" === {}.toString.call(e)
    }
    function t(e, t) {
        if (1 !== e.nodeType)
            return [];
        var n = e.ownerDocument.defaultView.getComputedStyle(e, null);
        return t ? n[t] : n
    }
    function n(e) {
        return "HTML" === e.nodeName ? e : e.parentNode || e.host
    }
    function i(e) {
        if (!e)
            return document.body;
        switch (e.nodeName) {
        case "HTML":
        case "BODY":
            return e.ownerDocument.body;
        case "#document":
            return e.body
        }
        var o = t(e)
          , r = o.overflow
          , a = o.overflowX
          , s = o.overflowY;
        return /(auto|scroll|overlay)/.test(r + s + a) ? e : i(n(e))
    }
    function o(e) {
        return e && e.referenceNode ? e.referenceNode : e
    }
    function r(e) {
        return 11 === e ? $ : 10 === e ? G : $ || G
    }
    function a(e) {
        if (!e)
            return document.documentElement;
        for (var n = r(10) ? document.body : null, i = e.offsetParent || null; i === n && e.nextElementSibling; )
            i = (e = e.nextElementSibling).offsetParent;
        var o = i && i.nodeName;
        return o && "BODY" !== o && "HTML" !== o ? -1 !== ["TH", "TD", "TABLE"].indexOf(i.nodeName) && "static" === t(i, "position") ? a(i) : i : e ? e.ownerDocument.documentElement : document.documentElement
    }
    function s(e) {
        return null === e.parentNode ? e : s(e.parentNode)
    }
    function l(e, t) {
        if (!(e && e.nodeType && t && t.nodeType))
            return document.documentElement;
        var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING
          , i = n ? e : t
          , o = n ? t : e
          , r = document.createRange();
        r.setStart(i, 0),
        r.setEnd(o, 0);
        var u = r.commonAncestorContainer;
        if (e !== u && t !== u || i.contains(o))
            return function(e) {
                var t = e.nodeName;
                return "BODY" !== t && ("HTML" === t || a(e.firstElementChild) === e)
            }(u) ? u : a(u);
        var d = s(e);
        return d.host ? l(d.host, t) : l(e, s(t).host)
    }
    function u(e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "top"
          , n = "top" === t ? "scrollTop" : "scrollLeft"
          , i = e.nodeName;
        if ("BODY" === i || "HTML" === i) {
            var o = e.ownerDocument.documentElement
              , r = e.ownerDocument.scrollingElement || o;
            return r[n]
        }
        return e[n]
    }
    function d(e, t) {
        var n = 2 < arguments.length && void 0 !== arguments[2] && arguments[2]
          , i = u(t, "top")
          , o = u(t, "left")
          , r = n ? -1 : 1;
        return e.top += i * r,
        e.bottom += i * r,
        e.left += o * r,
        e.right += o * r,
        e
    }
    function c(e, t) {
        var n = "x" === t ? "Left" : "Top"
          , i = "Left" == n ? "Right" : "Bottom";
        return parseFloat(e["border" + n + "Width"], 10) + parseFloat(e["border" + i + "Width"], 10)
    }
    function f(e, t, n, i) {
        return V(t["offset" + e], t["scroll" + e], n["client" + e], n["offset" + e], n["scroll" + e], r(10) ? parseInt(n["offset" + e]) + parseInt(i["margin" + ("Height" === e ? "Top" : "Left")]) + parseInt(i["margin" + ("Height" === e ? "Bottom" : "Right")]) : 0)
    }
    function h(e) {
        var t = e.body
          , n = e.documentElement
          , i = r(10) && getComputedStyle(n);
        return {
            height: f("Height", t, n, i),
            width: f("Width", t, n, i)
        }
    }
    function p(e) {
        return te({}, e, {
            right: e.left + e.width,
            bottom: e.top + e.height
        })
    }
    function g(e) {
        var n = {};
        try {
            if (r(10)) {
                n = e.getBoundingClientRect();
                var i = u(e, "top")
                  , o = u(e, "left");
                n.top += i,
                n.left += o,
                n.bottom += i,
                n.right += o
            } else
                n = e.getBoundingClientRect()
        } catch (e) {}
        var a = {
            left: n.left,
            top: n.top,
            width: n.right - n.left,
            height: n.bottom - n.top
        }
          , s = "HTML" === e.nodeName ? h(e.ownerDocument) : {}
          , l = s.width || e.clientWidth || a.width
          , d = s.height || e.clientHeight || a.height
          , f = e.offsetWidth - l
          , g = e.offsetHeight - d;
        if (f || g) {
            var m = t(e);
            f -= c(m, "x"),
            g -= c(m, "y"),
            a.width -= f,
            a.height -= g
        }
        return p(a)
    }
    function m(e, n) {
        var o = 2 < arguments.length && void 0 !== arguments[2] && arguments[2]
          , a = r(10)
          , s = "HTML" === n.nodeName
          , l = g(e)
          , u = g(n)
          , c = i(e)
          , f = t(n)
          , h = parseFloat(f.borderTopWidth, 10)
          , m = parseFloat(f.borderLeftWidth, 10);
        o && s && (u.top = V(u.top, 0),
        u.left = V(u.left, 0));
        var v = p({
            top: l.top - u.top - h,
            left: l.left - u.left - m,
            width: l.width,
            height: l.height
        });
        if (v.marginTop = 0,
        v.marginLeft = 0,
        !a && s) {
            var _ = parseFloat(f.marginTop, 10)
              , b = parseFloat(f.marginLeft, 10);
            v.top -= h - _,
            v.bottom -= h - _,
            v.left -= m - b,
            v.right -= m - b,
            v.marginTop = _,
            v.marginLeft = b
        }
        return (a && !o ? n.contains(c) : n === c && "BODY" !== c.nodeName) && (v = d(v, n)),
        v
    }
    function v(e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1]
          , n = e.ownerDocument.documentElement
          , i = m(e, n)
          , o = V(n.clientWidth, window.innerWidth || 0)
          , r = V(n.clientHeight, window.innerHeight || 0)
          , a = t ? 0 : u(n)
          , s = t ? 0 : u(n, "left")
          , l = {
            top: a - i.top + i.marginTop,
            left: s - i.left + i.marginLeft,
            width: o,
            height: r
        };
        return p(l)
    }
    function _(e) {
        var i = e.nodeName;
        if ("BODY" === i || "HTML" === i)
            return !1;
        if ("fixed" === t(e, "position"))
            return !0;
        var o = n(e);
        return !!o && _(o)
    }
    function b(e) {
        if (!e || !e.parentElement || r())
            return document.documentElement;
        for (var n = e.parentElement; n && "none" === t(n, "transform"); )
            n = n.parentElement;
        return n || document.documentElement
    }
    function y(e, t, r, a) {
        var s = 4 < arguments.length && void 0 !== arguments[4] && arguments[4]
          , u = {
            top: 0,
            left: 0
        }
          , d = s ? b(e) : l(e, o(t));
        if ("viewport" === a)
            u = v(d, s);
        else {
            var c;
            "scrollParent" === a ? "BODY" === (c = i(n(t))).nodeName && (c = e.ownerDocument.documentElement) : c = "window" === a ? e.ownerDocument.documentElement : a;
            var f = m(c, d, s);
            if ("HTML" !== c.nodeName || _(d))
                u = f;
            else {
                var p = h(e.ownerDocument)
                  , g = p.height
                  , y = p.width;
                u.top += f.top - f.marginTop,
                u.bottom = g + f.top,
                u.left += f.left - f.marginLeft,
                u.right = y + f.left
            }
        }
        var w = "number" == typeof (r = r || 0);
        return u.left += w ? r : r.left || 0,
        u.top += w ? r : r.top || 0,
        u.right -= w ? r : r.right || 0,
        u.bottom -= w ? r : r.bottom || 0,
        u
    }
    function w(e) {
        return e.width * e.height
    }
    function E(e, t, n, i, o) {
        var r = 5 < arguments.length && void 0 !== arguments[5] ? arguments[5] : 0;
        if (-1 === e.indexOf("auto"))
            return e;
        var a = y(n, i, r, o)
          , s = {
            top: {
                width: a.width,
                height: t.top - a.top
            },
            right: {
                width: a.right - t.right,
                height: a.height
            },
            bottom: {
                width: a.width,
                height: a.bottom - t.bottom
            },
            left: {
                width: t.left - a.left,
                height: a.height
            }
        }
          , l = Object.keys(s).map((function(e) {
            return te({
                key: e
            }, s[e], {
                area: w(s[e])
            })
        }
        )).sort((function(e, t) {
            return t.area - e.area
        }
        ))
          , u = l.filter((function(e) {
            var t = e.width
              , i = e.height;
            return t >= n.clientWidth && i >= n.clientHeight
        }
        ))
          , d = 0 < u.length ? u[0].key : l[0].key
          , c = e.split("-")[1];
        return d + (c ? "-" + c : "")
    }
    function S(e, t, n) {
        var i = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null
          , r = i ? b(t) : l(t, o(n));
        return m(n, r, i)
    }
    function T(e) {
        var t = e.ownerDocument.defaultView.getComputedStyle(e)
          , n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0)
          , i = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0);
        return {
            width: e.offsetWidth + i,
            height: e.offsetHeight + n
        }
    }
    function C(e) {
        var t = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
        };
        return e.replace(/left|right|bottom|top/g, (function(e) {
            return t[e]
        }
        ))
    }
    function I(e, t, n) {
        n = n.split("-")[0];
        var i = T(e)
          , o = {
            width: i.width,
            height: i.height
        }
          , r = -1 !== ["right", "left"].indexOf(n)
          , a = r ? "top" : "left"
          , s = r ? "left" : "top"
          , l = r ? "height" : "width"
          , u = r ? "width" : "height";
        return o[a] = t[a] + t[l] / 2 - i[l] / 2,
        o[s] = n === s ? t[s] - i[u] : t[C(s)],
        o
    }
    function k(e, t) {
        return Array.prototype.find ? e.find(t) : e.filter(t)[0]
    }
    function D(t, n, i) {
        var o = void 0 === i ? t : t.slice(0, function(e, t, n) {
            if (Array.prototype.findIndex)
                return e.findIndex((function(e) {
                    return e[t] === n
                }
                ));
            var i = k(e, (function(e) {
                return e[t] === n
            }
            ));
            return e.indexOf(i)
        }(t, "name", i));
        return o.forEach((function(t) {
            t.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
            var i = t.function || t.fn;
            t.enabled && e(i) && (n.offsets.popper = p(n.offsets.popper),
            n.offsets.reference = p(n.offsets.reference),
            n = i(n, t))
        }
        )),
        n
    }
    function A() {
        if (!this.state.isDestroyed) {
            var e = {
                instance: this,
                styles: {},
                arrowStyles: {},
                attributes: {},
                flipped: !1,
                offsets: {}
            };
            e.offsets.reference = S(this.state, this.popper, this.reference, this.options.positionFixed),
            e.placement = E(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding),
            e.originalPlacement = e.placement,
            e.positionFixed = this.options.positionFixed,
            e.offsets.popper = I(this.popper, e.offsets.reference, e.placement),
            e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute",
            e = D(this.modifiers, e),
            this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0,
            this.options.onCreate(e))
        }
    }
    function N(e, t) {
        return e.some((function(e) {
            var n = e.name;
            return e.enabled && n === t
        }
        ))
    }
    function x(e) {
        for (var t = [!1, "ms", "Webkit", "Moz", "O"], n = e.charAt(0).toUpperCase() + e.slice(1), i = 0; i < t.length; i++) {
            var o = t[i]
              , r = o ? "" + o + n : e;
            if (void 0 !== document.body.style[r])
                return r
        }
        return null
    }
    function j() {
        return this.state.isDestroyed = !0,
        N(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"),
        this.popper.style.position = "",
        this.popper.style.top = "",
        this.popper.style.left = "",
        this.popper.style.right = "",
        this.popper.style.bottom = "",
        this.popper.style.willChange = "",
        this.popper.style[x("transform")] = ""),
        this.disableEventListeners(),
        this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper),
        this
    }
    function O(e) {
        var t = e.ownerDocument;
        return t ? t.defaultView : window
    }
    function L(e, t, n, o) {
        var r = "BODY" === e.nodeName
          , a = r ? e.ownerDocument.defaultView : e;
        a.addEventListener(t, n, {
            passive: !0
        }),
        r || L(i(a.parentNode), t, n, o),
        o.push(a)
    }
    function H(e, t, n, o) {
        n.updateBound = o,
        O(e).addEventListener("resize", n.updateBound, {
            passive: !0
        });
        var r = i(e);
        return L(r, "scroll", n.updateBound, n.scrollParents),
        n.scrollElement = r,
        n.eventsEnabled = !0,
        n
    }
    function P() {
        this.state.eventsEnabled || (this.state = H(this.reference, this.options, this.state, this.scheduleUpdate))
    }
    function B() {
        this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate),
        this.state = function(e, t) {
            return O(e).removeEventListener("resize", t.updateBound),
            t.scrollParents.forEach((function(e) {
                e.removeEventListener("scroll", t.updateBound)
            }
            )),
            t.updateBound = null,
            t.scrollParents = [],
            t.scrollElement = null,
            t.eventsEnabled = !1,
            t
        }(this.reference, this.state))
    }
    function R(e) {
        return "" !== e && !isNaN(parseFloat(e)) && isFinite(e)
    }
    function F(e, t) {
        Object.keys(t).forEach((function(n) {
            var i = "";
            -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(n) && R(t[n]) && (i = "px"),
            e.style[n] = t[n] + i
        }
        ))
    }
    function U(e, t, n) {
        var i = k(e, (function(e) {
            return e.name === t
        }
        ))
          , o = !!i && e.some((function(e) {
            return e.name === n && e.enabled && e.order < i.order
        }
        ));
        if (!o) {
            var r = "`" + t + "`";
            console.warn("`" + n + "` modifier is required by " + r + " modifier in order to work, be sure to include it before " + r + "!")
        }
        return o
    }
    function Q(e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1]
          , n = oe.indexOf(e)
          , i = oe.slice(n + 1).concat(oe.slice(0, n));
        return t ? i.reverse() : i
    }
    function q(e, t, n, i) {
        var o = [0, 0]
          , r = -1 !== ["right", "left"].indexOf(i)
          , a = e.split(/(\+|\-)/).map((function(e) {
            return e.trim()
        }
        ))
          , s = a.indexOf(k(a, (function(e) {
            return -1 !== e.search(/,|\s/)
        }
        )));
        a[s] && -1 === a[s].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
        var l = /\s*,\s*|\s+/
          , u = -1 === s ? [a] : [a.slice(0, s).concat([a[s].split(l)[0]]), [a[s].split(l)[1]].concat(a.slice(s + 1))];
        return u = u.map((function(e, i) {
            var o = (1 === i ? !r : r) ? "height" : "width"
              , a = !1;
            return e.reduce((function(e, t) {
                return "" === e[e.length - 1] && -1 !== ["+", "-"].indexOf(t) ? (e[e.length - 1] = t,
                a = !0,
                e) : a ? (e[e.length - 1] += t,
                a = !1,
                e) : e.concat(t)
            }
            ), []).map((function(e) {
                return function(e, t, n, i) {
                    var o = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/)
                      , r = +o[1]
                      , a = o[2];
                    if (!r)
                        return e;
                    if (0 === a.indexOf("%")) {
                        return p("%p" === a ? n : i)[t] / 100 * r
                    }
                    return "vh" === a || "vw" === a ? ("vh" === a ? V(document.documentElement.clientHeight, window.innerHeight || 0) : V(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * r : r
                }(e, o, t, n)
            }
            ))
        }
        )),
        u.forEach((function(e, t) {
            e.forEach((function(n, i) {
                R(n) && (o[t] += n * ("-" === e[i - 1] ? -1 : 1))
            }
            ))
        }
        )),
        o
    }
    var M = Math.min
      , W = Math.floor
      , z = Math.round
      , V = Math.max
      , Y = "undefined" != typeof window && "undefined" != typeof document && "undefined" != typeof navigator
      , X = function() {
        for (var e = ["Edge", "Trident", "Firefox"], t = 0; t < e.length; t += 1)
            if (Y && 0 <= navigator.userAgent.indexOf(e[t]))
                return 1;
        return 0
    }()
      , K = Y && window.Promise ? function(e) {
        var t = !1;
        return function() {
            t || (t = !0,
            window.Promise.resolve().then((function() {
                t = !1,
                e()
            }
            )))
        }
    }
    : function(e) {
        var t = !1;
        return function() {
            t || (t = !0,
            setTimeout((function() {
                t = !1,
                e()
            }
            ), X))
        }
    }
      , $ = Y && !(!window.MSInputMethodContext || !document.documentMode)
      , G = Y && /MSIE 10/.test(navigator.userAgent)
      , J = function(e, t) {
        if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function")
    }
      , Z = function() {
        function e(e, t) {
            for (var n, i = 0; i < t.length; i++)
                (n = t[i]).enumerable = n.enumerable || !1,
                n.configurable = !0,
                "value"in n && (n.writable = !0),
                Object.defineProperty(e, n.key, n)
        }
        return function(t, n, i) {
            return n && e(t.prototype, n),
            i && e(t, i),
            t
        }
    }()
      , ee = function(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
      , te = Object.assign || function(e) {
        for (var t, n = 1; n < arguments.length; n++)
            for (var i in t = arguments[n])
                Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e
    }
      , ne = Y && /Firefox/i.test(navigator.userAgent)
      , ie = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"]
      , oe = ie.slice(3)
      , re = "flip"
      , ae = "clockwise"
      , se = "counterclockwise"
      , le = function() {
        function t(n, i) {
            var o = this
              , r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
            J(this, t),
            this.scheduleUpdate = function() {
                return requestAnimationFrame(o.update)
            }
            ,
            this.update = K(this.update.bind(this)),
            this.options = te({}, t.Defaults, r),
            this.state = {
                isDestroyed: !1,
                isCreated: !1,
                scrollParents: []
            },
            this.reference = n && n.jquery ? n[0] : n,
            this.popper = i && i.jquery ? i[0] : i,
            this.options.modifiers = {},
            Object.keys(te({}, t.Defaults.modifiers, r.modifiers)).forEach((function(e) {
                o.options.modifiers[e] = te({}, t.Defaults.modifiers[e] || {}, r.modifiers ? r.modifiers[e] : {})
            }
            )),
            this.modifiers = Object.keys(this.options.modifiers).map((function(e) {
                return te({
                    name: e
                }, o.options.modifiers[e])
            }
            )).sort((function(e, t) {
                return e.order - t.order
            }
            )),
            this.modifiers.forEach((function(t) {
                t.enabled && e(t.onLoad) && t.onLoad(o.reference, o.popper, o.options, t, o.state)
            }
            )),
            this.update();
            var a = this.options.eventsEnabled;
            a && this.enableEventListeners(),
            this.state.eventsEnabled = a
        }
        return Z(t, [{
            key: "update",
            value: function() {
                return A.call(this)
            }
        }, {
            key: "destroy",
            value: function() {
                return j.call(this)
            }
        }, {
            key: "enableEventListeners",
            value: function() {
                return P.call(this)
            }
        }, {
            key: "disableEventListeners",
            value: function() {
                return B.call(this)
            }
        }]),
        t
    }();
    return le.Utils = ("undefined" == typeof window ? global : window).PopperUtils,
    le.placements = ie,
    le.Defaults = {
        placement: "bottom",
        positionFixed: !1,
        eventsEnabled: !0,
        removeOnDestroy: !1,
        onCreate: function() {},
        onUpdate: function() {},
        modifiers: {
            shift: {
                order: 100,
                enabled: !0,
                fn: function(e) {
                    var t = e.placement
                      , n = t.split("-")[0]
                      , i = t.split("-")[1];
                    if (i) {
                        var o = e.offsets
                          , r = o.reference
                          , a = o.popper
                          , s = -1 !== ["bottom", "top"].indexOf(n)
                          , l = s ? "left" : "top"
                          , u = s ? "width" : "height"
                          , d = {
                            start: ee({}, l, r[l]),
                            end: ee({}, l, r[l] + r[u] - a[u])
                        };
                        e.offsets.popper = te({}, a, d[i])
                    }
                    return e
                }
            },
            offset: {
                order: 200,
                enabled: !0,
                fn: function(e, t) {
                    var n, i = t.offset, o = e.placement, r = e.offsets, a = r.popper, s = r.reference, l = o.split("-")[0];
                    return n = R(+i) ? [+i, 0] : q(i, a, s, l),
                    "left" === l ? (a.top += n[0],
                    a.left -= n[1]) : "right" === l ? (a.top += n[0],
                    a.left += n[1]) : "top" === l ? (a.left += n[0],
                    a.top -= n[1]) : "bottom" === l && (a.left += n[0],
                    a.top += n[1]),
                    e.popper = a,
                    e
                },
                offset: 0
            },
            preventOverflow: {
                order: 300,
                enabled: !0,
                fn: function(e, t) {
                    var n = t.boundariesElement || a(e.instance.popper);
                    e.instance.reference === n && (n = a(n));
                    var i = x("transform")
                      , o = e.instance.popper.style
                      , r = o.top
                      , s = o.left
                      , l = o[i];
                    o.top = "",
                    o.left = "",
                    o[i] = "";
                    var u = y(e.instance.popper, e.instance.reference, t.padding, n, e.positionFixed);
                    o.top = r,
                    o.left = s,
                    o[i] = l,
                    t.boundaries = u;
                    var d = t.priority
                      , c = e.offsets.popper
                      , f = {
                        primary: function(e) {
                            var n = c[e];
                            return c[e] < u[e] && !t.escapeWithReference && (n = V(c[e], u[e])),
                            ee({}, e, n)
                        },
                        secondary: function(e) {
                            var n = "right" === e ? "left" : "top"
                              , i = c[n];
                            return c[e] > u[e] && !t.escapeWithReference && (i = M(c[n], u[e] - ("right" === e ? c.width : c.height))),
                            ee({}, n, i)
                        }
                    };
                    return d.forEach((function(e) {
                        var t = -1 === ["left", "top"].indexOf(e) ? "secondary" : "primary";
                        c = te({}, c, f[t](e))
                    }
                    )),
                    e.offsets.popper = c,
                    e
                },
                priority: ["left", "right", "top", "bottom"],
                padding: 5,
                boundariesElement: "scrollParent"
            },
            keepTogether: {
                order: 400,
                enabled: !0,
                fn: function(e) {
                    var t = e.offsets
                      , n = t.popper
                      , i = t.reference
                      , o = e.placement.split("-")[0]
                      , r = W
                      , a = -1 !== ["top", "bottom"].indexOf(o)
                      , s = a ? "right" : "bottom"
                      , l = a ? "left" : "top"
                      , u = a ? "width" : "height";
                    return n[s] < r(i[l]) && (e.offsets.popper[l] = r(i[l]) - n[u]),
                    n[l] > r(i[s]) && (e.offsets.popper[l] = r(i[s])),
                    e
                }
            },
            arrow: {
                order: 500,
                enabled: !0,
                fn: function(e, n) {
                    var i;
                    if (!U(e.instance.modifiers, "arrow", "keepTogether"))
                        return e;
                    var o = n.element;
                    if ("string" == typeof o) {
                        if (!(o = e.instance.popper.querySelector(o)))
                            return e
                    } else if (!e.instance.popper.contains(o))
                        return console.warn("WARNING: `arrow.element` must be child of its popper element!"),
                        e;
                    var r = e.placement.split("-")[0]
                      , a = e.offsets
                      , s = a.popper
                      , l = a.reference
                      , u = -1 !== ["left", "right"].indexOf(r)
                      , d = u ? "height" : "width"
                      , c = u ? "Top" : "Left"
                      , f = c.toLowerCase()
                      , h = u ? "left" : "top"
                      , g = u ? "bottom" : "right"
                      , m = T(o)[d];
                    l[g] - m < s[f] && (e.offsets.popper[f] -= s[f] - (l[g] - m)),
                    l[f] + m > s[g] && (e.offsets.popper[f] += l[f] + m - s[g]),
                    e.offsets.popper = p(e.offsets.popper);
                    var v = l[f] + l[d] / 2 - m / 2
                      , _ = t(e.instance.popper)
                      , b = parseFloat(_["margin" + c], 10)
                      , y = parseFloat(_["border" + c + "Width"], 10)
                      , w = v - e.offsets.popper[f] - b - y;
                    return w = V(M(s[d] - m, w), 0),
                    e.arrowElement = o,
                    e.offsets.arrow = (ee(i = {}, f, z(w)),
                    ee(i, h, ""),
                    i),
                    e
                },
                element: "[x-arrow]"
            },
            flip: {
                order: 600,
                enabled: !0,
                fn: function(e, t) {
                    if (N(e.instance.modifiers, "inner"))
                        return e;
                    if (e.flipped && e.placement === e.originalPlacement)
                        return e;
                    var n = y(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed)
                      , i = e.placement.split("-")[0]
                      , o = C(i)
                      , r = e.placement.split("-")[1] || ""
                      , a = [];
                    switch (t.behavior) {
                    case re:
                        a = [i, o];
                        break;
                    case ae:
                        a = Q(i);
                        break;
                    case se:
                        a = Q(i, !0);
                        break;
                    default:
                        a = t.behavior
                    }
                    return a.forEach((function(s, l) {
                        if (i !== s || a.length === l + 1)
                            return e;
                        i = e.placement.split("-")[0],
                        o = C(i);
                        var u = e.offsets.popper
                          , d = e.offsets.reference
                          , c = W
                          , f = "left" === i && c(u.right) > c(d.left) || "right" === i && c(u.left) < c(d.right) || "top" === i && c(u.bottom) > c(d.top) || "bottom" === i && c(u.top) < c(d.bottom)
                          , h = c(u.left) < c(n.left)
                          , p = c(u.right) > c(n.right)
                          , g = c(u.top) < c(n.top)
                          , m = c(u.bottom) > c(n.bottom)
                          , v = "left" === i && h || "right" === i && p || "top" === i && g || "bottom" === i && m
                          , _ = -1 !== ["top", "bottom"].indexOf(i)
                          , b = !!t.flipVariations && (_ && "start" === r && h || _ && "end" === r && p || !_ && "start" === r && g || !_ && "end" === r && m)
                          , y = !!t.flipVariationsByContent && (_ && "start" === r && p || _ && "end" === r && h || !_ && "start" === r && m || !_ && "end" === r && g)
                          , w = b || y;
                        (f || v || w) && (e.flipped = !0,
                        (f || v) && (i = a[l + 1]),
                        w && (r = function(e) {
                            return "end" === e ? "start" : "start" === e ? "end" : e
                        }(r)),
                        e.placement = i + (r ? "-" + r : ""),
                        e.offsets.popper = te({}, e.offsets.popper, I(e.instance.popper, e.offsets.reference, e.placement)),
                        e = D(e.instance.modifiers, e, "flip"))
                    }
                    )),
                    e
                },
                behavior: "flip",
                padding: 5,
                boundariesElement: "viewport",
                flipVariations: !1,
                flipVariationsByContent: !1
            },
            inner: {
                order: 700,
                enabled: !1,
                fn: function(e) {
                    var t = e.placement
                      , n = t.split("-")[0]
                      , i = e.offsets
                      , o = i.popper
                      , r = i.reference
                      , a = -1 !== ["left", "right"].indexOf(n)
                      , s = -1 === ["top", "left"].indexOf(n);
                    return o[a ? "left" : "top"] = r[n] - (s ? o[a ? "width" : "height"] : 0),
                    e.placement = C(t),
                    e.offsets.popper = p(o),
                    e
                }
            },
            hide: {
                order: 800,
                enabled: !0,
                fn: function(e) {
                    if (!U(e.instance.modifiers, "hide", "preventOverflow"))
                        return e;
                    var t = e.offsets.reference
                      , n = k(e.instance.modifiers, (function(e) {
                        return "preventOverflow" === e.name
                    }
                    )).boundaries;
                    if (t.bottom < n.top || t.left > n.right || t.top > n.bottom || t.right < n.left) {
                        if (!0 === e.hide)
                            return e;
                        e.hide = !0,
                        e.attributes["x-out-of-boundaries"] = ""
                    } else {
                        if (!1 === e.hide)
                            return e;
                        e.hide = !1,
                        e.attributes["x-out-of-boundaries"] = !1
                    }
                    return e
                }
            },
            computeStyle: {
                order: 850,
                enabled: !0,
                fn: function(e, t) {
                    var n = t.x
                      , i = t.y
                      , o = e.offsets.popper
                      , r = k(e.instance.modifiers, (function(e) {
                        return "applyStyle" === e.name
                    }
                    )).gpuAcceleration;
                    void 0 !== r && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                    var s, l, u = void 0 === r ? t.gpuAcceleration : r, d = a(e.instance.popper), c = g(d), f = {
                        position: o.position
                    }, h = function(e, t) {
                        var n = e.offsets
                          , i = n.popper
                          , o = n.reference
                          , r = z
                          , a = function(e) {
                            return e
                        }
                          , s = r(o.width)
                          , l = r(i.width)
                          , u = -1 !== ["left", "right"].indexOf(e.placement)
                          , d = -1 !== e.placement.indexOf("-")
                          , c = t ? u || d || s % 2 == l % 2 ? r : W : a
                          , f = t ? r : a;
                        return {
                            left: c(1 == s % 2 && 1 == l % 2 && !d && t ? i.left - 1 : i.left),
                            top: f(i.top),
                            bottom: f(i.bottom),
                            right: c(i.right)
                        }
                    }(e, 2 > window.devicePixelRatio || !ne), p = "bottom" === n ? "top" : "bottom", m = "right" === i ? "left" : "right", v = x("transform");
                    if (l = "bottom" == p ? "HTML" === d.nodeName ? -d.clientHeight + h.bottom : -c.height + h.bottom : h.top,
                    s = "right" == m ? "HTML" === d.nodeName ? -d.clientWidth + h.right : -c.width + h.right : h.left,
                    u && v)
                        f[v] = "translate3d(" + s + "px, " + l + "px, 0)",
                        f[p] = 0,
                        f[m] = 0,
                        f.willChange = "transform";
                    else {
                        var _ = "bottom" == p ? -1 : 1
                          , b = "right" == m ? -1 : 1;
                        f[p] = l * _,
                        f[m] = s * b,
                        f.willChange = p + ", " + m
                    }
                    var y = {
                        "x-placement": e.placement
                    };
                    return e.attributes = te({}, y, e.attributes),
                    e.styles = te({}, f, e.styles),
                    e.arrowStyles = te({}, e.offsets.arrow, e.arrowStyles),
                    e
                },
                gpuAcceleration: !0,
                x: "bottom",
                y: "right"
            },
            applyStyle: {
                order: 900,
                enabled: !0,
                fn: function(e) {
                    return F(e.instance.popper, e.styles),
                    function(e, t) {
                        Object.keys(t).forEach((function(n) {
                            !1 === t[n] ? e.removeAttribute(n) : e.setAttribute(n, t[n])
                        }
                        ))
                    }(e.instance.popper, e.attributes),
                    e.arrowElement && Object.keys(e.arrowStyles).length && F(e.arrowElement, e.arrowStyles),
                    e
                },
                onLoad: function(e, t, n, i, o) {
                    var r = S(o, t, e, n.positionFixed)
                      , a = E(n.placement, r, t, e, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
                    return t.setAttribute("x-placement", a),
                    F(t, {
                        position: n.positionFixed ? "fixed" : "absolute"
                    }),
                    n
                },
                gpuAcceleration: void 0
            }
        }
    },
    le
}
)),
function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? t(exports, require("jquery"), require("popper.js")) : "function" == typeof define && define.amd ? define(["exports", "jquery", "popper.js"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).bootstrap = {}, e.jQuery, e.Popper)
}(this, (function(e, t, n) {
    "use strict";
    function i(e) {
        return e && "object" == typeof e && "default"in e ? e : {
            default: e
        }
    }
    var o = i(t)
      , r = i(n);
    function a(e, t) {
        for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1,
            i.configurable = !0,
            "value"in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i)
        }
    }
    function s(e, t, n) {
        return t && a(e.prototype, t),
        n && a(e, n),
        e
    }
    function l() {
        return (l = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var i in n)
                    Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
            }
            return e
        }
        ).apply(this, arguments)
    }
    var u = {
        TRANSITION_END: "bsTransitionEnd",
        getUID: function(e) {
            do {
                e += ~~(1e6 * Math.random())
            } while (document.getElementById(e));
            return e
        },
        getSelectorFromElement: function(e) {
            var t = e.getAttribute("data-target");
            if (!t || "#" === t) {
                var n = e.getAttribute("href");
                t = n && "#" !== n ? n.trim() : ""
            }
            try {
                return document.querySelector(t) ? t : null
            } catch (e) {
                return null
            }
        },
        getTransitionDurationFromElement: function(e) {
            if (!e)
                return 0;
            var t = o.default(e).css("transition-duration")
              , n = o.default(e).css("transition-delay")
              , i = parseFloat(t)
              , r = parseFloat(n);
            return i || r ? (t = t.split(",")[0],
            n = n.split(",")[0],
            1e3 * (parseFloat(t) + parseFloat(n))) : 0
        },
        reflow: function(e) {
            return e.offsetHeight
        },
        triggerTransitionEnd: function(e) {
            o.default(e).trigger("transitionend")
        },
        supportsTransitionEnd: function() {
            return Boolean("transitionend")
        },
        isElement: function(e) {
            return (e[0] || e).nodeType
        },
        typeCheckConfig: function(e, t, n) {
            for (var i in n)
                if (Object.prototype.hasOwnProperty.call(n, i)) {
                    var o = n[i]
                      , r = t[i]
                      , a = r && u.isElement(r) ? "element" : null === (s = r) || void 0 === s ? "" + s : {}.toString.call(s).match(/\s([a-z]+)/i)[1].toLowerCase();
                    if (!new RegExp(o).test(a))
                        throw new Error(e.toUpperCase() + ': Option "' + i + '" provided type "' + a + '" but expected type "' + o + '".')
                }
            var s
        },
        findShadowRoot: function(e) {
            if (!document.documentElement.attachShadow)
                return null;
            if ("function" == typeof e.getRootNode) {
                var t = e.getRootNode();
                return t instanceof ShadowRoot ? t : null
            }
            return e instanceof ShadowRoot ? e : e.parentNode ? u.findShadowRoot(e.parentNode) : null
        },
        jQueryDetection: function() {
            if (void 0 === o.default)
                throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
            var e = o.default.fn.jquery.split(" ")[0].split(".");
            if (e[0] < 2 && e[1] < 9 || 1 === e[0] && 9 === e[1] && e[2] < 1 || e[0] >= 4)
                throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0")
        }
    };
    u.jQueryDetection(),
    o.default.fn.emulateTransitionEnd = function(e) {
        var t = this
          , n = !1;
        return o.default(this).one(u.TRANSITION_END, (function() {
            n = !0
        }
        )),
        setTimeout((function() {
            n || u.triggerTransitionEnd(t)
        }
        ), e),
        this
    }
    ,
    o.default.event.special[u.TRANSITION_END] = {
        bindType: "transitionend",
        delegateType: "transitionend",
        handle: function(e) {
            if (o.default(e.target).is(this))
                return e.handleObj.handler.apply(this, arguments)
        }
    };
    var d = "alert"
      , c = o.default.fn[d]
      , f = function() {
        function e(e) {
            this._element = e
        }
        var t = e.prototype;
        return t.close = function(e) {
            var t = this._element;
            e && (t = this._getRootElement(e)),
            this._triggerCloseEvent(t).isDefaultPrevented() || this._removeElement(t)
        }
        ,
        t.dispose = function() {
            o.default.removeData(this._element, "bs.alert"),
            this._element = null
        }
        ,
        t._getRootElement = function(e) {
            var t = u.getSelectorFromElement(e)
              , n = !1;
            return t && (n = document.querySelector(t)),
            n || (n = o.default(e).closest(".alert")[0]),
            n
        }
        ,
        t._triggerCloseEvent = function(e) {
            var t = o.default.Event("close.bs.alert");
            return o.default(e).trigger(t),
            t
        }
        ,
        t._removeElement = function(e) {
            var t = this;
            if (o.default(e).removeClass("show"),
            o.default(e).hasClass("fade")) {
                var n = u.getTransitionDurationFromElement(e);
                o.default(e).one(u.TRANSITION_END, (function(n) {
                    return t._destroyElement(e, n)
                }
                )).emulateTransitionEnd(n)
            } else
                this._destroyElement(e)
        }
        ,
        t._destroyElement = function(e) {
            o.default(e).detach().trigger("closed.bs.alert").remove()
        }
        ,
        e._jQueryInterface = function(t) {
            return this.each((function() {
                var n = o.default(this)
                  , i = n.data("bs.alert");
                i || (i = new e(this),
                n.data("bs.alert", i)),
                "close" === t && i[t](this)
            }
            ))
        }
        ,
        e._handleDismiss = function(e) {
            return function(t) {
                t && t.preventDefault(),
                e.close(this)
            }
        }
        ,
        s(e, null, [{
            key: "VERSION",
            get: function() {
                return "4.5.3"
            }
        }]),
        e
    }();
    o.default(document).on("click.bs.alert.data-api", '[data-dismiss="alert"]', f._handleDismiss(new f)),
    o.default.fn[d] = f._jQueryInterface,
    o.default.fn[d].Constructor = f,
    o.default.fn[d].noConflict = function() {
        return o.default.fn[d] = c,
        f._jQueryInterface
    }
    ;
    var h = o.default.fn.button
      , p = function() {
        function e(e) {
            this._element = e,
            this.shouldAvoidTriggerChange = !1
        }
        var t = e.prototype;
        return t.toggle = function() {
            var e = !0
              , t = !0
              , n = o.default(this._element).closest('[data-toggle="buttons"]')[0];
            if (n) {
                var i = this._element.querySelector('input:not([type="hidden"])');
                if (i) {
                    if ("radio" === i.type)
                        if (i.checked && this._element.classList.contains("active"))
                            e = !1;
                        else {
                            var r = n.querySelector(".active");
                            r && o.default(r).removeClass("active")
                        }
                    e && ("checkbox" !== i.type && "radio" !== i.type || (i.checked = !this._element.classList.contains("active")),
                    this.shouldAvoidTriggerChange || o.default(i).trigger("change")),
                    i.focus(),
                    t = !1
                }
            }
            this._element.hasAttribute("disabled") || this._element.classList.contains("disabled") || (t && this._element.setAttribute("aria-pressed", !this._element.classList.contains("active")),
            e && o.default(this._element).toggleClass("active"))
        }
        ,
        t.dispose = function() {
            o.default.removeData(this._element, "bs.button"),
            this._element = null
        }
        ,
        e._jQueryInterface = function(t, n) {
            return this.each((function() {
                var i = o.default(this)
                  , r = i.data("bs.button");
                r || (r = new e(this),
                i.data("bs.button", r)),
                r.shouldAvoidTriggerChange = n,
                "toggle" === t && r[t]()
            }
            ))
        }
        ,
        s(e, null, [{
            key: "VERSION",
            get: function() {
                return "4.5.3"
            }
        }]),
        e
    }();
    o.default(document).on("click.bs.button.data-api", '[data-toggle^="button"]', (function(e) {
        var t = e.target
          , n = t;
        if (o.default(t).hasClass("btn") || (t = o.default(t).closest(".btn")[0]),
        !t || t.hasAttribute("disabled") || t.classList.contains("disabled"))
            e.preventDefault();
        else {
            var i = t.querySelector('input:not([type="hidden"])');
            if (i && (i.hasAttribute("disabled") || i.classList.contains("disabled")))
                return void e.preventDefault();
            "INPUT" !== n.tagName && "LABEL" === t.tagName || p._jQueryInterface.call(o.default(t), "toggle", "INPUT" === n.tagName)
        }
    }
    )).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', (function(e) {
        var t = o.default(e.target).closest(".btn")[0];
        o.default(t).toggleClass("focus", /^focus(in)?$/.test(e.type))
    }
    )),
    o.default(window).on("load.bs.button.data-api", (function() {
        for (var e = [].slice.call(document.querySelectorAll('[data-toggle="buttons"] .btn')), t = 0, n = e.length; t < n; t++) {
            var i = e[t]
              , o = i.querySelector('input:not([type="hidden"])');
            o.checked || o.hasAttribute("checked") ? i.classList.add("active") : i.classList.remove("active")
        }
        for (var r = 0, a = (e = [].slice.call(document.querySelectorAll('[data-toggle="button"]'))).length; r < a; r++) {
            var s = e[r];
            "true" === s.getAttribute("aria-pressed") ? s.classList.add("active") : s.classList.remove("active")
        }
    }
    )),
    o.default.fn.button = p._jQueryInterface,
    o.default.fn.button.Constructor = p,
    o.default.fn.button.noConflict = function() {
        return o.default.fn.button = h,
        p._jQueryInterface
    }
    ;
    var g = "carousel"
      , m = o.default.fn[g]
      , v = {
        interval: 5e3,
        keyboard: !0,
        slide: !1,
        pause: "hover",
        wrap: !0,
        touch: !0
    }
      , _ = {
        interval: "(number|boolean)",
        keyboard: "boolean",
        slide: "(boolean|string)",
        pause: "(string|boolean)",
        wrap: "boolean",
        touch: "boolean"
    }
      , b = {
        TOUCH: "touch",
        PEN: "pen"
    }
      , y = function() {
        function e(e, t) {
            this._items = null,
            this._interval = null,
            this._activeElement = null,
            this._isPaused = !1,
            this._isSliding = !1,
            this.touchTimeout = null,
            this.touchStartX = 0,
            this.touchDeltaX = 0,
            this._config = this._getConfig(t),
            this._element = e,
            this._indicatorsElement = this._element.querySelector(".carousel-indicators"),
            this._touchSupported = "ontouchstart"in document.documentElement || navigator.maxTouchPoints > 0,
            this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent),
            this._addEventListeners()
        }
        var t = e.prototype;
        return t.next = function() {
            this._isSliding || this._slide("next")
        }
        ,
        t.nextWhenVisible = function() {
            var e = o.default(this._element);
            !document.hidden && e.is(":visible") && "hidden" !== e.css("visibility") && this.next()
        }
        ,
        t.prev = function() {
            this._isSliding || this._slide("prev")
        }
        ,
        t.pause = function(e) {
            e || (this._isPaused = !0),
            this._element.querySelector(".carousel-item-next, .carousel-item-prev") && (u.triggerTransitionEnd(this._element),
            this.cycle(!0)),
            clearInterval(this._interval),
            this._interval = null
        }
        ,
        t.cycle = function(e) {
            e || (this._isPaused = !1),
            this._interval && (clearInterval(this._interval),
            this._interval = null),
            this._config.interval && !this._isPaused && (this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval))
        }
        ,
        t.to = function(e) {
            var t = this;
            this._activeElement = this._element.querySelector(".active.carousel-item");
            var n = this._getItemIndex(this._activeElement);
            if (!(e > this._items.length - 1 || e < 0))
                if (this._isSliding)
                    o.default(this._element).one("slid.bs.carousel", (function() {
                        return t.to(e)
                    }
                    ));
                else {
                    if (n === e)
                        return this.pause(),
                        void this.cycle();
                    var i = e > n ? "next" : "prev";
                    this._slide(i, this._items[e])
                }
        }
        ,
        t.dispose = function() {
            o.default(this._element).off(".bs.carousel"),
            o.default.removeData(this._element, "bs.carousel"),
            this._items = null,
            this._config = null,
            this._element = null,
            this._interval = null,
            this._isPaused = null,
            this._isSliding = null,
            this._activeElement = null,
            this._indicatorsElement = null
        }
        ,
        t._getConfig = function(e) {
            return e = l({}, v, e),
            u.typeCheckConfig(g, e, _),
            e
        }
        ,
        t._handleSwipe = function() {
            var e = Math.abs(this.touchDeltaX);
            if (!(e <= 40)) {
                var t = e / this.touchDeltaX;
                this.touchDeltaX = 0,
                t > 0 && this.prev(),
                t < 0 && this.next()
            }
        }
        ,
        t._addEventListeners = function() {
            var e = this;
            this._config.keyboard && o.default(this._element).on("keydown.bs.carousel", (function(t) {
                return e._keydown(t)
            }
            )),
            "hover" === this._config.pause && o.default(this._element).on("mouseenter.bs.carousel", (function(t) {
                return e.pause(t)
            }
            )).on("mouseleave.bs.carousel", (function(t) {
                return e.cycle(t)
            }
            )),
            this._config.touch && this._addTouchEventListeners()
        }
        ,
        t._addTouchEventListeners = function() {
            var e = this;
            if (this._touchSupported) {
                var t = function(t) {
                    e._pointerEvent && b[t.originalEvent.pointerType.toUpperCase()] ? e.touchStartX = t.originalEvent.clientX : e._pointerEvent || (e.touchStartX = t.originalEvent.touches[0].clientX)
                }
                  , n = function(t) {
                    e._pointerEvent && b[t.originalEvent.pointerType.toUpperCase()] && (e.touchDeltaX = t.originalEvent.clientX - e.touchStartX),
                    e._handleSwipe(),
                    "hover" === e._config.pause && (e.pause(),
                    e.touchTimeout && clearTimeout(e.touchTimeout),
                    e.touchTimeout = setTimeout((function(t) {
                        return e.cycle(t)
                    }
                    ), 500 + e._config.interval))
                };
                o.default(this._element.querySelectorAll(".carousel-item img")).on("dragstart.bs.carousel", (function(e) {
                    return e.preventDefault()
                }
                )),
                this._pointerEvent ? (o.default(this._element).on("pointerdown.bs.carousel", (function(e) {
                    return t(e)
                }
                )),
                o.default(this._element).on("pointerup.bs.carousel", (function(e) {
                    return n(e)
                }
                )),
                this._element.classList.add("pointer-event")) : (o.default(this._element).on("touchstart.bs.carousel", (function(e) {
                    return t(e)
                }
                )),
                o.default(this._element).on("touchmove.bs.carousel", (function(t) {
                    return function(t) {
                        t.originalEvent.touches && t.originalEvent.touches.length > 1 ? e.touchDeltaX = 0 : e.touchDeltaX = t.originalEvent.touches[0].clientX - e.touchStartX
                    }(t)
                }
                )),
                o.default(this._element).on("touchend.bs.carousel", (function(e) {
                    return n(e)
                }
                )))
            }
        }
        ,
        t._keydown = function(e) {
            if (!/input|textarea/i.test(e.target.tagName))
                switch (e.which) {
                case 37:
                    e.preventDefault(),
                    this.prev();
                    break;
                case 39:
                    e.preventDefault(),
                    this.next()
                }
        }
        ,
        t._getItemIndex = function(e) {
            return this._items = e && e.parentNode ? [].slice.call(e.parentNode.querySelectorAll(".carousel-item")) : [],
            this._items.indexOf(e)
        }
        ,
        t._getItemByDirection = function(e, t) {
            var n = "next" === e
              , i = "prev" === e
              , o = this._getItemIndex(t)
              , r = this._items.length - 1;
            if ((i && 0 === o || n && o === r) && !this._config.wrap)
                return t;
            var a = (o + ("prev" === e ? -1 : 1)) % this._items.length;
            return -1 === a ? this._items[this._items.length - 1] : this._items[a]
        }
        ,
        t._triggerSlideEvent = function(e, t) {
            var n = this._getItemIndex(e)
              , i = this._getItemIndex(this._element.querySelector(".active.carousel-item"))
              , r = o.default.Event("slide.bs.carousel", {
                relatedTarget: e,
                direction: t,
                from: i,
                to: n
            });
            return o.default(this._element).trigger(r),
            r
        }
        ,
        t._setActiveIndicatorElement = function(e) {
            if (this._indicatorsElement) {
                var t = [].slice.call(this._indicatorsElement.querySelectorAll(".active"));
                o.default(t).removeClass("active");
                var n = this._indicatorsElement.children[this._getItemIndex(e)];
                n && o.default(n).addClass("active")
            }
        }
        ,
        t._slide = function(e, t) {
            var n, i, r, a = this, s = this._element.querySelector(".active.carousel-item"), l = this._getItemIndex(s), d = t || s && this._getItemByDirection(e, s), c = this._getItemIndex(d), f = Boolean(this._interval);
            if ("next" === e ? (n = "carousel-item-left",
            i = "carousel-item-next",
            r = "left") : (n = "carousel-item-right",
            i = "carousel-item-prev",
            r = "right"),
            d && o.default(d).hasClass("active"))
                this._isSliding = !1;
            else if (!this._triggerSlideEvent(d, r).isDefaultPrevented() && s && d) {
                this._isSliding = !0,
                f && this.pause(),
                this._setActiveIndicatorElement(d);
                var h = o.default.Event("slid.bs.carousel", {
                    relatedTarget: d,
                    direction: r,
                    from: l,
                    to: c
                });
                if (o.default(this._element).hasClass("slide")) {
                    o.default(d).addClass(i),
                    u.reflow(d),
                    o.default(s).addClass(n),
                    o.default(d).addClass(n);
                    var p = parseInt(d.getAttribute("data-interval"), 10);
                    p ? (this._config.defaultInterval = this._config.defaultInterval || this._config.interval,
                    this._config.interval = p) : this._config.interval = this._config.defaultInterval || this._config.interval;
                    var g = u.getTransitionDurationFromElement(s);
                    o.default(s).one(u.TRANSITION_END, (function() {
                        o.default(d).removeClass(n + " " + i).addClass("active"),
                        o.default(s).removeClass("active " + i + " " + n),
                        a._isSliding = !1,
                        setTimeout((function() {
                            return o.default(a._element).trigger(h)
                        }
                        ), 0)
                    }
                    )).emulateTransitionEnd(g)
                } else
                    o.default(s).removeClass("active"),
                    o.default(d).addClass("active"),
                    this._isSliding = !1,
                    o.default(this._element).trigger(h);
                f && this.cycle()
            }
        }
        ,
        e._jQueryInterface = function(t) {
            return this.each((function() {
                var n = o.default(this).data("bs.carousel")
                  , i = l({}, v, o.default(this).data());
                "object" == typeof t && (i = l({}, i, t));
                var r = "string" == typeof t ? t : i.slide;
                if (n || (n = new e(this,i),
                o.default(this).data("bs.carousel", n)),
                "number" == typeof t)
                    n.to(t);
                else if ("string" == typeof r) {
                    if (void 0 === n[r])
                        throw new TypeError('No method named "' + r + '"');
                    n[r]()
                } else
                    i.interval && i.ride && (n.pause(),
                    n.cycle())
            }
            ))
        }
        ,
        e._dataApiClickHandler = function(t) {
            var n = u.getSelectorFromElement(this);
            if (n) {
                var i = o.default(n)[0];
                if (i && o.default(i).hasClass("carousel")) {
                    var r = l({}, o.default(i).data(), o.default(this).data())
                      , a = this.getAttribute("data-slide-to");
                    a && (r.interval = !1),
                    e._jQueryInterface.call(o.default(i), r),
                    a && o.default(i).data("bs.carousel").to(a),
                    t.preventDefault()
                }
            }
        }
        ,
        s(e, null, [{
            key: "VERSION",
            get: function() {
                return "4.5.3"
            }
        }, {
            key: "Default",
            get: function() {
                return v
            }
        }]),
        e
    }();
    o.default(document).on("click.bs.carousel.data-api", "[data-slide], [data-slide-to]", y._dataApiClickHandler),
    o.default(window).on("load.bs.carousel.data-api", (function() {
        for (var e = [].slice.call(document.querySelectorAll('[data-ride="carousel"]')), t = 0, n = e.length; t < n; t++) {
            var i = o.default(e[t]);
            y._jQueryInterface.call(i, i.data())
        }
    }
    )),
    o.default.fn[g] = y._jQueryInterface,
    o.default.fn[g].Constructor = y,
    o.default.fn[g].noConflict = function() {
        return o.default.fn[g] = m,
        y._jQueryInterface
    }
    ;
    var w = "collapse"
      , E = o.default.fn[w]
      , S = {
        toggle: !0,
        parent: ""
    }
      , T = {
        toggle: "boolean",
        parent: "(string|element)"
    }
      , C = function() {
        function e(e, t) {
            this._isTransitioning = !1,
            this._element = e,
            this._config = this._getConfig(t),
            this._triggerArray = [].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#' + e.id + '"],[data-toggle="collapse"][data-target="#' + e.id + '"]'));
            for (var n = [].slice.call(document.querySelectorAll('[data-toggle="collapse"]')), i = 0, o = n.length; i < o; i++) {
                var r = n[i]
                  , a = u.getSelectorFromElement(r)
                  , s = [].slice.call(document.querySelectorAll(a)).filter((function(t) {
                    return t === e
                }
                ));
                null !== a && s.length > 0 && (this._selector = a,
                this._triggerArray.push(r))
            }
            this._parent = this._config.parent ? this._getParent() : null,
            this._config.parent || this._addAriaAndCollapsedClass(this._element, this._triggerArray),
            this._config.toggle && this.toggle()
        }
        var t = e.prototype;
        return t.toggle = function() {
            o.default(this._element).hasClass("show") ? this.hide() : this.show()
        }
        ,
        t.show = function() {
            var t, n, i = this;
            if (!(this._isTransitioning || o.default(this._element).hasClass("show") || (this._parent && 0 === (t = [].slice.call(this._parent.querySelectorAll(".show, .collapsing")).filter((function(e) {
                return "string" == typeof i._config.parent ? e.getAttribute("data-parent") === i._config.parent : e.classList.contains("collapse")
            }
            ))).length && (t = null),
            t && (n = o.default(t).not(this._selector).data("bs.collapse")) && n._isTransitioning))) {
                var r = o.default.Event("show.bs.collapse");
                if (o.default(this._element).trigger(r),
                !r.isDefaultPrevented()) {
                    t && (e._jQueryInterface.call(o.default(t).not(this._selector), "hide"),
                    n || o.default(t).data("bs.collapse", null));
                    var a = this._getDimension();
                    o.default(this._element).removeClass("collapse").addClass("collapsing"),
                    this._element.style[a] = 0,
                    this._triggerArray.length && o.default(this._triggerArray).removeClass("collapsed").attr("aria-expanded", !0),
                    this.setTransitioning(!0);
                    var s = "scroll" + (a[0].toUpperCase() + a.slice(1))
                      , l = u.getTransitionDurationFromElement(this._element);
                    o.default(this._element).one(u.TRANSITION_END, (function() {
                        o.default(i._element).removeClass("collapsing").addClass("collapse show"),
                        i._element.style[a] = "",
                        i.setTransitioning(!1),
                        o.default(i._element).trigger("shown.bs.collapse")
                    }
                    )).emulateTransitionEnd(l),
                    this._element.style[a] = this._element[s] + "px"
                }
            }
        }
        ,
        t.hide = function() {
            var e = this;
            if (!this._isTransitioning && o.default(this._element).hasClass("show")) {
                var t = o.default.Event("hide.bs.collapse");
                if (o.default(this._element).trigger(t),
                !t.isDefaultPrevented()) {
                    var n = this._getDimension();
                    this._element.style[n] = this._element.getBoundingClientRect()[n] + "px",
                    u.reflow(this._element),
                    o.default(this._element).addClass("collapsing").removeClass("collapse show");
                    var i = this._triggerArray.length;
                    if (i > 0)
                        for (var r = 0; r < i; r++) {
                            var a = this._triggerArray[r]
                              , s = u.getSelectorFromElement(a);
                            null !== s && (o.default([].slice.call(document.querySelectorAll(s))).hasClass("show") || o.default(a).addClass("collapsed").attr("aria-expanded", !1))
                        }
                    this.setTransitioning(!0),
                    this._element.style[n] = "";
                    var l = u.getTransitionDurationFromElement(this._element);
                    o.default(this._element).one(u.TRANSITION_END, (function() {
                        e.setTransitioning(!1),
                        o.default(e._element).removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")
                    }
                    )).emulateTransitionEnd(l)
                }
            }
        }
        ,
        t.setTransitioning = function(e) {
            this._isTransitioning = e
        }
        ,
        t.dispose = function() {
            o.default.removeData(this._element, "bs.collapse"),
            this._config = null,
            this._parent = null,
            this._element = null,
            this._triggerArray = null,
            this._isTransitioning = null
        }
        ,
        t._getConfig = function(e) {
            return (e = l({}, S, e)).toggle = Boolean(e.toggle),
            u.typeCheckConfig(w, e, T),
            e
        }
        ,
        t._getDimension = function() {
            return o.default(this._element).hasClass("width") ? "width" : "height"
        }
        ,
        t._getParent = function() {
            var t, n = this;
            u.isElement(this._config.parent) ? (t = this._config.parent,
            void 0 !== this._config.parent.jquery && (t = this._config.parent[0])) : t = document.querySelector(this._config.parent);
            var i = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]'
              , r = [].slice.call(t.querySelectorAll(i));
            return o.default(r).each((function(t, i) {
                n._addAriaAndCollapsedClass(e._getTargetFromElement(i), [i])
            }
            )),
            t
        }
        ,
        t._addAriaAndCollapsedClass = function(e, t) {
            var n = o.default(e).hasClass("show");
            t.length && o.default(t).toggleClass("collapsed", !n).attr("aria-expanded", n)
        }
        ,
        e._getTargetFromElement = function(e) {
            var t = u.getSelectorFromElement(e);
            return t ? document.querySelector(t) : null
        }
        ,
        e._jQueryInterface = function(t) {
            return this.each((function() {
                var n = o.default(this)
                  , i = n.data("bs.collapse")
                  , r = l({}, S, n.data(), "object" == typeof t && t ? t : {});
                if (!i && r.toggle && "string" == typeof t && /show|hide/.test(t) && (r.toggle = !1),
                i || (i = new e(this,r),
                n.data("bs.collapse", i)),
                "string" == typeof t) {
                    if (void 0 === i[t])
                        throw new TypeError('No method named "' + t + '"');
                    i[t]()
                }
            }
            ))
        }
        ,
        s(e, null, [{
            key: "VERSION",
            get: function() {
                return "4.5.3"
            }
        }, {
            key: "Default",
            get: function() {
                return S
            }
        }]),
        e
    }();
    o.default(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', (function(e) {
        "A" === e.currentTarget.tagName && e.preventDefault();
        var t = o.default(this)
          , n = u.getSelectorFromElement(this)
          , i = [].slice.call(document.querySelectorAll(n));
        o.default(i).each((function() {
            var e = o.default(this)
              , n = e.data("bs.collapse") ? "toggle" : t.data();
            C._jQueryInterface.call(e, n)
        }
        ))
    }
    )),
    o.default.fn[w] = C._jQueryInterface,
    o.default.fn[w].Constructor = C,
    o.default.fn[w].noConflict = function() {
        return o.default.fn[w] = E,
        C._jQueryInterface
    }
    ;
    var I = "dropdown"
      , k = o.default.fn[I]
      , D = new RegExp("38|40|27")
      , A = {
        offset: 0,
        flip: !0,
        boundary: "scrollParent",
        reference: "toggle",
        display: "dynamic",
        popperConfig: null
    }
      , N = {
        offset: "(number|string|function)",
        flip: "boolean",
        boundary: "(string|element)",
        reference: "(string|element)",
        display: "string",
        popperConfig: "(null|object)"
    }
      , x = function() {
        function e(e, t) {
            this._element = e,
            this._popper = null,
            this._config = this._getConfig(t),
            this._menu = this._getMenuElement(),
            this._inNavbar = this._detectNavbar(),
            this._addEventListeners()
        }
        var t = e.prototype;
        return t.toggle = function() {
            if (!this._element.disabled && !o.default(this._element).hasClass("disabled")) {
                var t = o.default(this._menu).hasClass("show");
                e._clearMenus(),
                t || this.show(!0)
            }
        }
        ,
        t.show = function(t) {
            if (void 0 === t && (t = !1),
            !(this._element.disabled || o.default(this._element).hasClass("disabled") || o.default(this._menu).hasClass("show"))) {
                var n = {
                    relatedTarget: this._element
                }
                  , i = o.default.Event("show.bs.dropdown", n)
                  , a = e._getParentFromElement(this._element);
                if (o.default(a).trigger(i),
                !i.isDefaultPrevented()) {
                    if (!this._inNavbar && t) {
                        if (void 0 === r.default)
                            throw new TypeError("Bootstrap's dropdowns require Popper.js (https://popper.js.org/)");
                        var s = this._element;
                        "parent" === this._config.reference ? s = a : u.isElement(this._config.reference) && (s = this._config.reference,
                        void 0 !== this._config.reference.jquery && (s = this._config.reference[0])),
                        "scrollParent" !== this._config.boundary && o.default(a).addClass("position-static"),
                        this._popper = new r.default(s,this._menu,this._getPopperConfig())
                    }
                    "ontouchstart"in document.documentElement && 0 === o.default(a).closest(".navbar-nav").length && o.default(document.body).children().on("mouseover", null, o.default.noop),
                    this._element.focus(),
                    this._element.setAttribute("aria-expanded", !0),
                    o.default(this._menu).toggleClass("show"),
                    o.default(a).toggleClass("show").trigger(o.default.Event("shown.bs.dropdown", n))
                }
            }
        }
        ,
        t.hide = function() {
            if (!this._element.disabled && !o.default(this._element).hasClass("disabled") && o.default(this._menu).hasClass("show")) {
                var t = {
                    relatedTarget: this._element
                }
                  , n = o.default.Event("hide.bs.dropdown", t)
                  , i = e._getParentFromElement(this._element);
                o.default(i).trigger(n),
                n.isDefaultPrevented() || (this._popper && this._popper.destroy(),
                o.default(this._menu).toggleClass("show"),
                o.default(i).toggleClass("show").trigger(o.default.Event("hidden.bs.dropdown", t)))
            }
        }
        ,
        t.dispose = function() {
            o.default.removeData(this._element, "bs.dropdown"),
            o.default(this._element).off(".bs.dropdown"),
            this._element = null,
            this._menu = null,
            null !== this._popper && (this._popper.destroy(),
            this._popper = null)
        }
        ,
        t.update = function() {
            this._inNavbar = this._detectNavbar(),
            null !== this._popper && this._popper.scheduleUpdate()
        }
        ,
        t._addEventListeners = function() {
            var e = this;
            o.default(this._element).on("click.bs.dropdown", (function(t) {
                t.preventDefault(),
                t.stopPropagation(),
                e.toggle()
            }
            ))
        }
        ,
        t._getConfig = function(e) {
            return e = l({}, this.constructor.Default, o.default(this._element).data(), e),
            u.typeCheckConfig(I, e, this.constructor.DefaultType),
            e
        }
        ,
        t._getMenuElement = function() {
            if (!this._menu) {
                var t = e._getParentFromElement(this._element);
                t && (this._menu = t.querySelector(".dropdown-menu"))
            }
            return this._menu
        }
        ,
        t._getPlacement = function() {
            var e = o.default(this._element.parentNode)
              , t = "bottom-start";
            return e.hasClass("dropup") ? t = o.default(this._menu).hasClass("dropdown-menu-right") ? "top-end" : "top-start" : e.hasClass("dropright") ? t = "right-start" : e.hasClass("dropleft") ? t = "left-start" : o.default(this._menu).hasClass("dropdown-menu-right") && (t = "bottom-end"),
            t
        }
        ,
        t._detectNavbar = function() {
            return o.default(this._element).closest(".navbar").length > 0
        }
        ,
        t._getOffset = function() {
            var e = this
              , t = {};
            return "function" == typeof this._config.offset ? t.fn = function(t) {
                return t.offsets = l({}, t.offsets, e._config.offset(t.offsets, e._element) || {}),
                t
            }
            : t.offset = this._config.offset,
            t
        }
        ,
        t._getPopperConfig = function() {
            var e = {
                placement: this._getPlacement(),
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        enabled: this._config.flip
                    },
                    preventOverflow: {
                        boundariesElement: this._config.boundary
                    }
                }
            };
            return "static" === this._config.display && (e.modifiers.applyStyle = {
                enabled: !1
            }),
            l({}, e, this._config.popperConfig)
        }
        ,
        e._jQueryInterface = function(t) {
            return this.each((function() {
                var n = o.default(this).data("bs.dropdown");
                if (n || (n = new e(this,"object" == typeof t ? t : null),
                o.default(this).data("bs.dropdown", n)),
                "string" == typeof t) {
                    if (void 0 === n[t])
                        throw new TypeError('No method named "' + t + '"');
                    n[t]()
                }
            }
            ))
        }
        ,
        e._clearMenus = function(t) {
            if (!t || 3 !== t.which && ("keyup" !== t.type || 9 === t.which))
                for (var n = [].slice.call(document.querySelectorAll('[data-toggle="dropdown"]')), i = 0, r = n.length; i < r; i++) {
                    var a = e._getParentFromElement(n[i])
                      , s = o.default(n[i]).data("bs.dropdown")
                      , l = {
                        relatedTarget: n[i]
                    };
                    if (t && "click" === t.type && (l.clickEvent = t),
                    s) {
                        var u = s._menu;
                        if (o.default(a).hasClass("show") && !(t && ("click" === t.type && /input|textarea/i.test(t.target.tagName) || "keyup" === t.type && 9 === t.which) && o.default.contains(a, t.target))) {
                            var d = o.default.Event("hide.bs.dropdown", l);
                            o.default(a).trigger(d),
                            d.isDefaultPrevented() || ("ontouchstart"in document.documentElement && o.default(document.body).children().off("mouseover", null, o.default.noop),
                            n[i].setAttribute("aria-expanded", "false"),
                            s._popper && s._popper.destroy(),
                            o.default(u).removeClass("show"),
                            o.default(a).removeClass("show").trigger(o.default.Event("hidden.bs.dropdown", l)))
                        }
                    }
                }
        }
        ,
        e._getParentFromElement = function(e) {
            var t, n = u.getSelectorFromElement(e);
            return n && (t = document.querySelector(n)),
            t || e.parentNode
        }
        ,
        e._dataApiKeydownHandler = function(t) {
            if (!(/input|textarea/i.test(t.target.tagName) ? 32 === t.which || 27 !== t.which && (40 !== t.which && 38 !== t.which || o.default(t.target).closest(".dropdown-menu").length) : !D.test(t.which)) && !this.disabled && !o.default(this).hasClass("disabled")) {
                var n = e._getParentFromElement(this)
                  , i = o.default(n).hasClass("show");
                if (i || 27 !== t.which) {
                    if (t.preventDefault(),
                    t.stopPropagation(),
                    !i || 27 === t.which || 32 === t.which)
                        return 27 === t.which && o.default(n.querySelector('[data-toggle="dropdown"]')).trigger("focus"),
                        void o.default(this).trigger("click");
                    var r = [].slice.call(n.querySelectorAll(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)")).filter((function(e) {
                        return o.default(e).is(":visible")
                    }
                    ));
                    if (0 !== r.length) {
                        var a = r.indexOf(t.target);
                        38 === t.which && a > 0 && a--,
                        40 === t.which && a < r.length - 1 && a++,
                        a < 0 && (a = 0),
                        r[a].focus()
                    }
                }
            }
        }
        ,
        s(e, null, [{
            key: "VERSION",
            get: function() {
                return "4.5.3"
            }
        }, {
            key: "Default",
            get: function() {
                return A
            }
        }, {
            key: "DefaultType",
            get: function() {
                return N
            }
        }]),
        e
    }();
    o.default(document).on("keydown.bs.dropdown.data-api", '[data-toggle="dropdown"]', x._dataApiKeydownHandler).on("keydown.bs.dropdown.data-api", ".dropdown-menu", x._dataApiKeydownHandler).on("click.bs.dropdown.data-api keyup.bs.dropdown.data-api", x._clearMenus).on("click.bs.dropdown.data-api", '[data-toggle="dropdown"]', (function(e) {
        e.preventDefault(),
        e.stopPropagation(),
        x._jQueryInterface.call(o.default(this), "toggle")
    }
    )).on("click.bs.dropdown.data-api", ".dropdown form", (function(e) {
        e.stopPropagation()
    }
    )),
    o.default.fn[I] = x._jQueryInterface,
    o.default.fn[I].Constructor = x,
    o.default.fn[I].noConflict = function() {
        return o.default.fn[I] = k,
        x._jQueryInterface
    }
    ;
    var j = o.default.fn.modal
      , O = {
        backdrop: !0,
        keyboard: !0,
        focus: !0,
        show: !0
    }
      , L = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        focus: "boolean",
        show: "boolean"
    }
      , H = function() {
        function e(e, t) {
            this._config = this._getConfig(t),
            this._element = e,
            this._dialog = e.querySelector(".modal-dialog"),
            this._backdrop = null,
            this._isShown = !1,
            this._isBodyOverflowing = !1,
            this._ignoreBackdropClick = !1,
            this._isTransitioning = !1,
            this._scrollbarWidth = 0
        }
        var t = e.prototype;
        return t.toggle = function(e) {
            return this._isShown ? this.hide() : this.show(e)
        }
        ,
        t.show = function(e) {
            var t = this;
            if (!this._isShown && !this._isTransitioning) {
                o.default(this._element).hasClass("fade") && (this._isTransitioning = !0);
                var n = o.default.Event("show.bs.modal", {
                    relatedTarget: e
                });
                o.default(this._element).trigger(n),
                this._isShown || n.isDefaultPrevented() || (this._isShown = !0,
                this._checkScrollbar(),
                this._setScrollbar(),
                this._adjustDialog(),
                this._setEscapeEvent(),
                this._setResizeEvent(),
                o.default(this._element).on("click.dismiss.bs.modal", '[data-dismiss="modal"]', (function(e) {
                    return t.hide(e)
                }
                )),
                o.default(this._dialog).on("mousedown.dismiss.bs.modal", (function() {
                    o.default(t._element).one("mouseup.dismiss.bs.modal", (function(e) {
                        o.default(e.target).is(t._element) && (t._ignoreBackdropClick = !0)
                    }
                    ))
                }
                )),
                this._showBackdrop((function() {
                    return t._showElement(e)
                }
                )))
            }
        }
        ,
        t.hide = function(e) {
            var t = this;
            if (e && e.preventDefault(),
            this._isShown && !this._isTransitioning) {
                var n = o.default.Event("hide.bs.modal");
                if (o.default(this._element).trigger(n),
                this._isShown && !n.isDefaultPrevented()) {
                    this._isShown = !1;
                    var i = o.default(this._element).hasClass("fade");
                    if (i && (this._isTransitioning = !0),
                    this._setEscapeEvent(),
                    this._setResizeEvent(),
                    o.default(document).off("focusin.bs.modal"),
                    o.default(this._element).removeClass("show"),
                    o.default(this._element).off("click.dismiss.bs.modal"),
                    o.default(this._dialog).off("mousedown.dismiss.bs.modal"),
                    i) {
                        var r = u.getTransitionDurationFromElement(this._element);
                        o.default(this._element).one(u.TRANSITION_END, (function(e) {
                            return t._hideModal(e)
                        }
                        )).emulateTransitionEnd(r)
                    } else
                        this._hideModal()
                }
            }
        }
        ,
        t.dispose = function() {
            [window, this._element, this._dialog].forEach((function(e) {
                return o.default(e).off(".bs.modal")
            }
            )),
            o.default(document).off("focusin.bs.modal"),
            o.default.removeData(this._element, "bs.modal"),
            this._config = null,
            this._element = null,
            this._dialog = null,
            this._backdrop = null,
            this._isShown = null,
            this._isBodyOverflowing = null,
            this._ignoreBackdropClick = null,
            this._isTransitioning = null,
            this._scrollbarWidth = null
        }
        ,
        t.handleUpdate = function() {
            this._adjustDialog()
        }
        ,
        t._getConfig = function(e) {
            return e = l({}, O, e),
            u.typeCheckConfig("modal", e, L),
            e
        }
        ,
        t._triggerBackdropTransition = function() {
            var e = this;
            if ("static" === this._config.backdrop) {
                var t = o.default.Event("hidePrevented.bs.modal");
                if (o.default(this._element).trigger(t),
                t.isDefaultPrevented())
                    return;
                var n = this._element.scrollHeight > document.documentElement.clientHeight;
                n || (this._element.style.overflowY = "hidden"),
                this._element.classList.add("modal-static");
                var i = u.getTransitionDurationFromElement(this._dialog);
                o.default(this._element).off(u.TRANSITION_END),
                o.default(this._element).one(u.TRANSITION_END, (function() {
                    e._element.classList.remove("modal-static"),
                    n || o.default(e._element).one(u.TRANSITION_END, (function() {
                        e._element.style.overflowY = ""
                    }
                    )).emulateTransitionEnd(e._element, i)
                }
                )).emulateTransitionEnd(i),
                this._element.focus()
            } else
                this.hide()
        }
        ,
        t._showElement = function(e) {
            var t = this
              , n = o.default(this._element).hasClass("fade")
              , i = this._dialog ? this._dialog.querySelector(".modal-body") : null;
            this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE || document.body.appendChild(this._element),
            this._element.style.display = "block",
            this._element.removeAttribute("aria-hidden"),
            this._element.setAttribute("aria-modal", !0),
            this._element.setAttribute("role", "dialog"),
            o.default(this._dialog).hasClass("modal-dialog-scrollable") && i ? i.scrollTop = 0 : this._element.scrollTop = 0,
            n && u.reflow(this._element),
            o.default(this._element).addClass("show"),
            this._config.focus && this._enforceFocus();
            var r = o.default.Event("shown.bs.modal", {
                relatedTarget: e
            })
              , a = function() {
                t._config.focus && t._element.focus(),
                t._isTransitioning = !1,
                o.default(t._element).trigger(r)
            };
            if (n) {
                var s = u.getTransitionDurationFromElement(this._dialog);
                o.default(this._dialog).one(u.TRANSITION_END, a).emulateTransitionEnd(s)
            } else
                a()
        }
        ,
        t._enforceFocus = function() {
            var e = this;
            o.default(document).off("focusin.bs.modal").on("focusin.bs.modal", (function(t) {
                document !== t.target && e._element !== t.target && 0 === o.default(e._element).has(t.target).length && e._element.focus()
            }
            ))
        }
        ,
        t._setEscapeEvent = function() {
            var e = this;
            this._isShown ? o.default(this._element).on("keydown.dismiss.bs.modal", (function(t) {
                e._config.keyboard && 27 === t.which ? (t.preventDefault(),
                e.hide()) : e._config.keyboard || 27 !== t.which || e._triggerBackdropTransition()
            }
            )) : this._isShown || o.default(this._element).off("keydown.dismiss.bs.modal")
        }
        ,
        t._setResizeEvent = function() {
            var e = this;
            this._isShown ? o.default(window).on("resize.bs.modal", (function(t) {
                return e.handleUpdate(t)
            }
            )) : o.default(window).off("resize.bs.modal")
        }
        ,
        t._hideModal = function() {
            var e = this;
            this._element.style.display = "none",
            this._element.setAttribute("aria-hidden", !0),
            this._element.removeAttribute("aria-modal"),
            this._element.removeAttribute("role"),
            this._isTransitioning = !1,
            this._showBackdrop((function() {
                o.default(document.body).removeClass("modal-open"),
                e._resetAdjustments(),
                e._resetScrollbar(),
                o.default(e._element).trigger("hidden.bs.modal")
            }
            ))
        }
        ,
        t._removeBackdrop = function() {
            this._backdrop && (o.default(this._backdrop).remove(),
            this._backdrop = null)
        }
        ,
        t._showBackdrop = function(e) {
            var t = this
              , n = o.default(this._element).hasClass("fade") ? "fade" : "";
            if (this._isShown && this._config.backdrop) {
                if (this._backdrop = document.createElement("div"),
                this._backdrop.className = "modal-backdrop",
                n && this._backdrop.classList.add(n),
                o.default(this._backdrop).appendTo(document.body),
                o.default(this._element).on("click.dismiss.bs.modal", (function(e) {
                    t._ignoreBackdropClick ? t._ignoreBackdropClick = !1 : e.target === e.currentTarget && t._triggerBackdropTransition()
                }
                )),
                n && u.reflow(this._backdrop),
                o.default(this._backdrop).addClass("show"),
                !e)
                    return;
                if (!n)
                    return void e();
                var i = u.getTransitionDurationFromElement(this._backdrop);
                o.default(this._backdrop).one(u.TRANSITION_END, e).emulateTransitionEnd(i)
            } else if (!this._isShown && this._backdrop) {
                o.default(this._backdrop).removeClass("show");
                var r = function() {
                    t._removeBackdrop(),
                    e && e()
                };
                if (o.default(this._element).hasClass("fade")) {
                    var a = u.getTransitionDurationFromElement(this._backdrop);
                    o.default(this._backdrop).one(u.TRANSITION_END, r).emulateTransitionEnd(a)
                } else
                    r()
            } else
                e && e()
        }
        ,
        t._adjustDialog = function() {
            var e = this._element.scrollHeight > document.documentElement.clientHeight;
            !this._isBodyOverflowing && e && (this._element.style.paddingLeft = this._scrollbarWidth + "px"),
            this._isBodyOverflowing && !e && (this._element.style.paddingRight = this._scrollbarWidth + "px")
        }
        ,
        t._resetAdjustments = function() {
            this._element.style.paddingLeft = "",
            this._element.style.paddingRight = ""
        }
        ,
        t._checkScrollbar = function() {
            var e = document.body.getBoundingClientRect();
            this._isBodyOverflowing = Math.round(e.left + e.right) < window.innerWidth,
            this._scrollbarWidth = this._getScrollbarWidth()
        }
        ,
        t._setScrollbar = function() {
            var e = this;
            if (this._isBodyOverflowing) {
                var t = [].slice.call(document.querySelectorAll(".fixed-top, .fixed-bottom, .is-fixed, .sticky-top"))
                  , n = [].slice.call(document.querySelectorAll(".sticky-top"));
                o.default(t).each((function(t, n) {
                    var i = n.style.paddingRight
                      , r = o.default(n).css("padding-right");
                    o.default(n).data("padding-right", i).css("padding-right", parseFloat(r) + e._scrollbarWidth + "px")
                }
                )),
                o.default(n).each((function(t, n) {
                    var i = n.style.marginRight
                      , r = o.default(n).css("margin-right");
                    o.default(n).data("margin-right", i).css("margin-right", parseFloat(r) - e._scrollbarWidth + "px")
                }
                ));
                var i = document.body.style.paddingRight
                  , r = o.default(document.body).css("padding-right");
                o.default(document.body).data("padding-right", i).css("padding-right", parseFloat(r) + this._scrollbarWidth + "px")
            }
            o.default(document.body).addClass("modal-open")
        }
        ,
        t._resetScrollbar = function() {
            var e = [].slice.call(document.querySelectorAll(".fixed-top, .fixed-bottom, .is-fixed, .sticky-top"));
            o.default(e).each((function(e, t) {
                var n = o.default(t).data("padding-right");
                o.default(t).removeData("padding-right"),
                t.style.paddingRight = n || ""
            }
            ));
            var t = [].slice.call(document.querySelectorAll(".sticky-top"));
            o.default(t).each((function(e, t) {
                var n = o.default(t).data("margin-right");
                void 0 !== n && o.default(t).css("margin-right", n).removeData("margin-right")
            }
            ));
            var n = o.default(document.body).data("padding-right");
            o.default(document.body).removeData("padding-right"),
            document.body.style.paddingRight = n || ""
        }
        ,
        t._getScrollbarWidth = function() {
            var e = document.createElement("div");
            e.className = "modal-scrollbar-measure",
            document.body.appendChild(e);
            var t = e.getBoundingClientRect().width - e.clientWidth;
            return document.body.removeChild(e),
            t
        }
        ,
        e._jQueryInterface = function(t, n) {
            return this.each((function() {
                var i = o.default(this).data("bs.modal")
                  , r = l({}, O, o.default(this).data(), "object" == typeof t && t ? t : {});
                if (i || (i = new e(this,r),
                o.default(this).data("bs.modal", i)),
                "string" == typeof t) {
                    if (void 0 === i[t])
                        throw new TypeError('No method named "' + t + '"');
                    i[t](n)
                } else
                    r.show && i.show(n)
            }
            ))
        }
        ,
        s(e, null, [{
            key: "VERSION",
            get: function() {
                return "4.5.3"
            }
        }, {
            key: "Default",
            get: function() {
                return O
            }
        }]),
        e
    }();
    o.default(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', (function(e) {
        var t, n = this, i = u.getSelectorFromElement(this);
        i && (t = document.querySelector(i));
        var r = o.default(t).data("bs.modal") ? "toggle" : l({}, o.default(t).data(), o.default(this).data());
        "A" !== this.tagName && "AREA" !== this.tagName || e.preventDefault();
        var a = o.default(t).one("show.bs.modal", (function(e) {
            e.isDefaultPrevented() || a.one("hidden.bs.modal", (function() {
                o.default(n).is(":visible") && n.focus()
            }
            ))
        }
        ));
        H._jQueryInterface.call(o.default(t), r, this)
    }
    )),
    o.default.fn.modal = H._jQueryInterface,
    o.default.fn.modal.Constructor = H,
    o.default.fn.modal.noConflict = function() {
        return o.default.fn.modal = j,
        H._jQueryInterface
    }
    ;
    var P = ["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"]
      , B = /^(?:(?:https?|mailto|ftp|tel|file):|[^#&/:?]*(?:[#/?]|$))/gi
      , R = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;
    function F(e, t, n) {
        if (0 === e.length)
            return e;
        if (n && "function" == typeof n)
            return n(e);
        for (var i = (new window.DOMParser).parseFromString(e, "text/html"), o = Object.keys(t), r = [].slice.call(i.body.querySelectorAll("*")), a = function(e, n) {
            var i = r[e]
              , a = i.nodeName.toLowerCase();
            if (-1 === o.indexOf(i.nodeName.toLowerCase()))
                return i.parentNode.removeChild(i),
                "continue";
            var s = [].slice.call(i.attributes)
              , l = [].concat(t["*"] || [], t[a] || []);
            s.forEach((function(e) {
                (function(e, t) {
                    var n = e.nodeName.toLowerCase();
                    if (-1 !== t.indexOf(n))
                        return -1 === P.indexOf(n) || Boolean(e.nodeValue.match(B) || e.nodeValue.match(R));
                    for (var i = t.filter((function(e) {
                        return e instanceof RegExp
                    }
                    )), o = 0, r = i.length; o < r; o++)
                        if (n.match(i[o]))
                            return !0;
                    return !1
                }
                )(e, l) || i.removeAttribute(e.nodeName)
            }
            ))
        }, s = 0, l = r.length; s < l; s++)
            a(s);
        return i.body.innerHTML
    }
    var U = "tooltip"
      , Q = o.default.fn[U]
      , q = new RegExp("(^|\\s)bs-tooltip\\S+","g")
      , M = ["sanitize", "whiteList", "sanitizeFn"]
      , W = {
        animation: "boolean",
        template: "string",
        title: "(string|element|function)",
        trigger: "string",
        delay: "(number|object)",
        html: "boolean",
        selector: "(string|boolean)",
        placement: "(string|function)",
        offset: "(number|string|function)",
        container: "(string|element|boolean)",
        fallbackPlacement: "(string|array)",
        boundary: "(string|element)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        whiteList: "object",
        popperConfig: "(null|object)"
    }
      , z = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: "right",
        BOTTOM: "bottom",
        LEFT: "left"
    }
      , V = {
        animation: !0,
        template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        selector: !1,
        placement: "top",
        offset: 0,
        container: !1,
        fallbackPlacement: "flip",
        boundary: "scrollParent",
        sanitize: !0,
        sanitizeFn: null,
        whiteList: {
            "*": ["class", "dir", "id", "lang", "role", /^aria-[\w-]*$/i],
            a: ["target", "href", "title", "rel"],
            area: [],
            b: [],
            br: [],
            col: [],
            code: [],
            div: [],
            em: [],
            hr: [],
            h1: [],
            h2: [],
            h3: [],
            h4: [],
            h5: [],
            h6: [],
            i: [],
            img: ["src", "srcset", "alt", "title", "width", "height"],
            li: [],
            ol: [],
            p: [],
            pre: [],
            s: [],
            small: [],
            span: [],
            sub: [],
            sup: [],
            strong: [],
            u: [],
            ul: []
        },
        popperConfig: null
    }
      , Y = {
        HIDE: "hide.bs.tooltip",
        HIDDEN: "hidden.bs.tooltip",
        SHOW: "show.bs.tooltip",
        SHOWN: "shown.bs.tooltip",
        INSERTED: "inserted.bs.tooltip",
        CLICK: "click.bs.tooltip",
        FOCUSIN: "focusin.bs.tooltip",
        FOCUSOUT: "focusout.bs.tooltip",
        MOUSEENTER: "mouseenter.bs.tooltip",
        MOUSELEAVE: "mouseleave.bs.tooltip"
    }
      , X = function() {
        function e(e, t) {
            if (void 0 === r.default)
                throw new TypeError("Bootstrap's tooltips require Popper.js (https://popper.js.org/)");
            this._isEnabled = !0,
            this._timeout = 0,
            this._hoverState = "",
            this._activeTrigger = {},
            this._popper = null,
            this.element = e,
            this.config = this._getConfig(t),
            this.tip = null,
            this._setListeners()
        }
        var t = e.prototype;
        return t.enable = function() {
            this._isEnabled = !0
        }
        ,
        t.disable = function() {
            this._isEnabled = !1
        }
        ,
        t.toggleEnabled = function() {
            this._isEnabled = !this._isEnabled
        }
        ,
        t.toggle = function(e) {
            if (this._isEnabled)
                if (e) {
                    var t = this.constructor.DATA_KEY
                      , n = o.default(e.currentTarget).data(t);
                    n || (n = new this.constructor(e.currentTarget,this._getDelegateConfig()),
                    o.default(e.currentTarget).data(t, n)),
                    n._activeTrigger.click = !n._activeTrigger.click,
                    n._isWithActiveTrigger() ? n._enter(null, n) : n._leave(null, n)
                } else {
                    if (o.default(this.getTipElement()).hasClass("show"))
                        return void this._leave(null, this);
                    this._enter(null, this)
                }
        }
        ,
        t.dispose = function() {
            clearTimeout(this._timeout),
            o.default.removeData(this.element, this.constructor.DATA_KEY),
            o.default(this.element).off(this.constructor.EVENT_KEY),
            o.default(this.element).closest(".modal").off("hide.bs.modal", this._hideModalHandler),
            this.tip && o.default(this.tip).remove(),
            this._isEnabled = null,
            this._timeout = null,
            this._hoverState = null,
            this._activeTrigger = null,
            this._popper && this._popper.destroy(),
            this._popper = null,
            this.element = null,
            this.config = null,
            this.tip = null
        }
        ,
        t.show = function() {
            var e = this;
            if ("none" === o.default(this.element).css("display"))
                throw new Error("Please use show on visible elements");
            var t = o.default.Event(this.constructor.Event.SHOW);
            if (this.isWithContent() && this._isEnabled) {
                o.default(this.element).trigger(t);
                var n = u.findShadowRoot(this.element)
                  , i = o.default.contains(null !== n ? n : this.element.ownerDocument.documentElement, this.element);
                if (t.isDefaultPrevented() || !i)
                    return;
                var a = this.getTipElement()
                  , s = u.getUID(this.constructor.NAME);
                a.setAttribute("id", s),
                this.element.setAttribute("aria-describedby", s),
                this.setContent(),
                this.config.animation && o.default(a).addClass("fade");
                var l = "function" == typeof this.config.placement ? this.config.placement.call(this, a, this.element) : this.config.placement
                  , d = this._getAttachment(l);
                this.addAttachmentClass(d);
                var c = this._getContainer();
                o.default(a).data(this.constructor.DATA_KEY, this),
                o.default.contains(this.element.ownerDocument.documentElement, this.tip) || o.default(a).appendTo(c),
                o.default(this.element).trigger(this.constructor.Event.INSERTED),
                this._popper = new r.default(this.element,a,this._getPopperConfig(d)),
                o.default(a).addClass("show"),
                "ontouchstart"in document.documentElement && o.default(document.body).children().on("mouseover", null, o.default.noop);
                var f = function() {
                    e.config.animation && e._fixTransition();
                    var t = e._hoverState;
                    e._hoverState = null,
                    o.default(e.element).trigger(e.constructor.Event.SHOWN),
                    "out" === t && e._leave(null, e)
                };
                if (o.default(this.tip).hasClass("fade")) {
                    var h = u.getTransitionDurationFromElement(this.tip);
                    o.default(this.tip).one(u.TRANSITION_END, f).emulateTransitionEnd(h)
                } else
                    f()
            }
        }
        ,
        t.hide = function(e) {
            var t = this
              , n = this.getTipElement()
              , i = o.default.Event(this.constructor.Event.HIDE)
              , r = function() {
                "show" !== t._hoverState && n.parentNode && n.parentNode.removeChild(n),
                t._cleanTipClass(),
                t.element.removeAttribute("aria-describedby"),
                o.default(t.element).trigger(t.constructor.Event.HIDDEN),
                null !== t._popper && t._popper.destroy(),
                e && e()
            };
            if (o.default(this.element).trigger(i),
            !i.isDefaultPrevented()) {
                if (o.default(n).removeClass("show"),
                "ontouchstart"in document.documentElement && o.default(document.body).children().off("mouseover", null, o.default.noop),
                this._activeTrigger.click = !1,
                this._activeTrigger.focus = !1,
                this._activeTrigger.hover = !1,
                o.default(this.tip).hasClass("fade")) {
                    var a = u.getTransitionDurationFromElement(n);
                    o.default(n).one(u.TRANSITION_END, r).emulateTransitionEnd(a)
                } else
                    r();
                this._hoverState = ""
            }
        }
        ,
        t.update = function() {
            null !== this._popper && this._popper.scheduleUpdate()
        }
        ,
        t.isWithContent = function() {
            return Boolean(this.getTitle())
        }
        ,
        t.addAttachmentClass = function(e) {
            o.default(this.getTipElement()).addClass("bs-tooltip-" + e)
        }
        ,
        t.getTipElement = function() {
            return this.tip = this.tip || o.default(this.config.template)[0],
            this.tip
        }
        ,
        t.setContent = function() {
            var e = this.getTipElement();
            this.setElementContent(o.default(e.querySelectorAll(".tooltip-inner")), this.getTitle()),
            o.default(e).removeClass("fade show")
        }
        ,
        t.setElementContent = function(e, t) {
            "object" != typeof t || !t.nodeType && !t.jquery ? this.config.html ? (this.config.sanitize && (t = F(t, this.config.whiteList, this.config.sanitizeFn)),
            e.html(t)) : e.text(t) : this.config.html ? o.default(t).parent().is(e) || e.empty().append(t) : e.text(o.default(t).text())
        }
        ,
        t.getTitle = function() {
            var e = this.element.getAttribute("data-original-title");
            return e || (e = "function" == typeof this.config.title ? this.config.title.call(this.element) : this.config.title),
            e
        }
        ,
        t._getPopperConfig = function(e) {
            var t = this;
            return l({}, {
                placement: e,
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        behavior: this.config.fallbackPlacement
                    },
                    arrow: {
                        element: ".arrow"
                    },
                    preventOverflow: {
                        boundariesElement: this.config.boundary
                    }
                },
                onCreate: function(e) {
                    e.originalPlacement !== e.placement && t._handlePopperPlacementChange(e)
                },
                onUpdate: function(e) {
                    return t._handlePopperPlacementChange(e)
                }
            }, this.config.popperConfig)
        }
        ,
        t._getOffset = function() {
            var e = this
              , t = {};
            return "function" == typeof this.config.offset ? t.fn = function(t) {
                return t.offsets = l({}, t.offsets, e.config.offset(t.offsets, e.element) || {}),
                t
            }
            : t.offset = this.config.offset,
            t
        }
        ,
        t._getContainer = function() {
            return !1 === this.config.container ? document.body : u.isElement(this.config.container) ? o.default(this.config.container) : o.default(document).find(this.config.container)
        }
        ,
        t._getAttachment = function(e) {
            return z[e.toUpperCase()]
        }
        ,
        t._setListeners = function() {
            var e = this;
            this.config.trigger.split(" ").forEach((function(t) {
                if ("click" === t)
                    o.default(e.element).on(e.constructor.Event.CLICK, e.config.selector, (function(t) {
                        return e.toggle(t)
                    }
                    ));
                else if ("manual" !== t) {
                    var n = "hover" === t ? e.constructor.Event.MOUSEENTER : e.constructor.Event.FOCUSIN
                      , i = "hover" === t ? e.constructor.Event.MOUSELEAVE : e.constructor.Event.FOCUSOUT;
                    o.default(e.element).on(n, e.config.selector, (function(t) {
                        return e._enter(t)
                    }
                    )).on(i, e.config.selector, (function(t) {
                        return e._leave(t)
                    }
                    ))
                }
            }
            )),
            this._hideModalHandler = function() {
                e.element && e.hide()
            }
            ,
            o.default(this.element).closest(".modal").on("hide.bs.modal", this._hideModalHandler),
            this.config.selector ? this.config = l({}, this.config, {
                trigger: "manual",
                selector: ""
            }) : this._fixTitle()
        }
        ,
        t._fixTitle = function() {
            var e = typeof this.element.getAttribute("data-original-title");
            (this.element.getAttribute("title") || "string" !== e) && (this.element.setAttribute("data-original-title", this.element.getAttribute("title") || ""),
            this.element.setAttribute("title", ""))
        }
        ,
        t._enter = function(e, t) {
            var n = this.constructor.DATA_KEY;
            (t = t || o.default(e.currentTarget).data(n)) || (t = new this.constructor(e.currentTarget,this._getDelegateConfig()),
            o.default(e.currentTarget).data(n, t)),
            e && (t._activeTrigger["focusin" === e.type ? "focus" : "hover"] = !0),
            o.default(t.getTipElement()).hasClass("show") || "show" === t._hoverState ? t._hoverState = "show" : (clearTimeout(t._timeout),
            t._hoverState = "show",
            t.config.delay && t.config.delay.show ? t._timeout = setTimeout((function() {
                "show" === t._hoverState && t.show()
            }
            ), t.config.delay.show) : t.show())
        }
        ,
        t._leave = function(e, t) {
            var n = this.constructor.DATA_KEY;
            (t = t || o.default(e.currentTarget).data(n)) || (t = new this.constructor(e.currentTarget,this._getDelegateConfig()),
            o.default(e.currentTarget).data(n, t)),
            e && (t._activeTrigger["focusout" === e.type ? "focus" : "hover"] = !1),
            t._isWithActiveTrigger() || (clearTimeout(t._timeout),
            t._hoverState = "out",
            t.config.delay && t.config.delay.hide ? t._timeout = setTimeout((function() {
                "out" === t._hoverState && t.hide()
            }
            ), t.config.delay.hide) : t.hide())
        }
        ,
        t._isWithActiveTrigger = function() {
            for (var e in this._activeTrigger)
                if (this._activeTrigger[e])
                    return !0;
            return !1
        }
        ,
        t._getConfig = function(e) {
            var t = o.default(this.element).data();
            return Object.keys(t).forEach((function(e) {
                -1 !== M.indexOf(e) && delete t[e]
            }
            )),
            "number" == typeof (e = l({}, this.constructor.Default, t, "object" == typeof e && e ? e : {})).delay && (e.delay = {
                show: e.delay,
                hide: e.delay
            }),
            "number" == typeof e.title && (e.title = e.title.toString()),
            "number" == typeof e.content && (e.content = e.content.toString()),
            u.typeCheckConfig(U, e, this.constructor.DefaultType),
            e.sanitize && (e.template = F(e.template, e.whiteList, e.sanitizeFn)),
            e
        }
        ,
        t._getDelegateConfig = function() {
            var e = {};
            if (this.config)
                for (var t in this.config)
                    this.constructor.Default[t] !== this.config[t] && (e[t] = this.config[t]);
            return e
        }
        ,
        t._cleanTipClass = function() {
            var e = o.default(this.getTipElement())
              , t = e.attr("class").match(q);
            null !== t && t.length && e.removeClass(t.join(""))
        }
        ,
        t._handlePopperPlacementChange = function(e) {
            this.tip = e.instance.popper,
            this._cleanTipClass(),
            this.addAttachmentClass(this._getAttachment(e.placement))
        }
        ,
        t._fixTransition = function() {
            var e = this.getTipElement()
              , t = this.config.animation;
            null === e.getAttribute("x-placement") && (o.default(e).removeClass("fade"),
            this.config.animation = !1,
            this.hide(),
            this.show(),
            this.config.animation = t)
        }
        ,
        e._jQueryInterface = function(t) {
            return this.each((function() {
                var n = o.default(this)
                  , i = n.data("bs.tooltip")
                  , r = "object" == typeof t && t;
                if ((i || !/dispose|hide/.test(t)) && (i || (i = new e(this,r),
                n.data("bs.tooltip", i)),
                "string" == typeof t)) {
                    if (void 0 === i[t])
                        throw new TypeError('No method named "' + t + '"');
                    i[t]()
                }
            }
            ))
        }
        ,
        s(e, null, [{
            key: "VERSION",
            get: function() {
                return "4.5.3"
            }
        }, {
            key: "Default",
            get: function() {
                return V
            }
        }, {
            key: "NAME",
            get: function() {
                return U
            }
        }, {
            key: "DATA_KEY",
            get: function() {
                return "bs.tooltip"
            }
        }, {
            key: "Event",
            get: function() {
                return Y
            }
        }, {
            key: "EVENT_KEY",
            get: function() {
                return ".bs.tooltip"
            }
        }, {
            key: "DefaultType",
            get: function() {
                return W
            }
        }]),
        e
    }();
    o.default.fn[U] = X._jQueryInterface,
    o.default.fn[U].Constructor = X,
    o.default.fn[U].noConflict = function() {
        return o.default.fn[U] = Q,
        X._jQueryInterface
    }
    ;
    var K = "popover"
      , $ = o.default.fn[K]
      , G = new RegExp("(^|\\s)bs-popover\\S+","g")
      , J = l({}, X.Default, {
        placement: "right",
        trigger: "click",
        content: "",
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    })
      , Z = l({}, X.DefaultType, {
        content: "(string|element|function)"
    })
      , ee = {
        HIDE: "hide.bs.popover",
        HIDDEN: "hidden.bs.popover",
        SHOW: "show.bs.popover",
        SHOWN: "shown.bs.popover",
        INSERTED: "inserted.bs.popover",
        CLICK: "click.bs.popover",
        FOCUSIN: "focusin.bs.popover",
        FOCUSOUT: "focusout.bs.popover",
        MOUSEENTER: "mouseenter.bs.popover",
        MOUSELEAVE: "mouseleave.bs.popover"
    }
      , te = function(e) {
        var t, n;
        function i() {
            return e.apply(this, arguments) || this
        }
        n = e,
        (t = i).prototype = Object.create(n.prototype),
        t.prototype.constructor = t,
        t.__proto__ = n;
        var r = i.prototype;
        return r.isWithContent = function() {
            return this.getTitle() || this._getContent()
        }
        ,
        r.addAttachmentClass = function(e) {
            o.default(this.getTipElement()).addClass("bs-popover-" + e)
        }
        ,
        r.getTipElement = function() {
            return this.tip = this.tip || o.default(this.config.template)[0],
            this.tip
        }
        ,
        r.setContent = function() {
            var e = o.default(this.getTipElement());
            this.setElementContent(e.find(".popover-header"), this.getTitle());
            var t = this._getContent();
            "function" == typeof t && (t = t.call(this.element)),
            this.setElementContent(e.find(".popover-body"), t),
            e.removeClass("fade show")
        }
        ,
        r._getContent = function() {
            return this.element.getAttribute("data-content") || this.config.content
        }
        ,
        r._cleanTipClass = function() {
            var e = o.default(this.getTipElement())
              , t = e.attr("class").match(G);
            null !== t && t.length > 0 && e.removeClass(t.join(""))
        }
        ,
        i._jQueryInterface = function(e) {
            return this.each((function() {
                var t = o.default(this).data("bs.popover")
                  , n = "object" == typeof e ? e : null;
                if ((t || !/dispose|hide/.test(e)) && (t || (t = new i(this,n),
                o.default(this).data("bs.popover", t)),
                "string" == typeof e)) {
                    if (void 0 === t[e])
                        throw new TypeError('No method named "' + e + '"');
                    t[e]()
                }
            }
            ))
        }
        ,
        s(i, null, [{
            key: "VERSION",
            get: function() {
                return "4.5.3"
            }
        }, {
            key: "Default",
            get: function() {
                return J
            }
        }, {
            key: "NAME",
            get: function() {
                return K
            }
        }, {
            key: "DATA_KEY",
            get: function() {
                return "bs.popover"
            }
        }, {
            key: "Event",
            get: function() {
                return ee
            }
        }, {
            key: "EVENT_KEY",
            get: function() {
                return ".bs.popover"
            }
        }, {
            key: "DefaultType",
            get: function() {
                return Z
            }
        }]),
        i
    }(X);
    o.default.fn[K] = te._jQueryInterface,
    o.default.fn[K].Constructor = te,
    o.default.fn[K].noConflict = function() {
        return o.default.fn[K] = $,
        te._jQueryInterface
    }
    ;
    var ne = "scrollspy"
      , ie = o.default.fn[ne]
      , oe = {
        offset: 10,
        method: "auto",
        target: ""
    }
      , re = {
        offset: "number",
        method: "string",
        target: "(string|element)"
    }
      , ae = function() {
        function e(e, t) {
            var n = this;
            this._element = e,
            this._scrollElement = "BODY" === e.tagName ? window : e,
            this._config = this._getConfig(t),
            this._selector = this._config.target + " .nav-link," + this._config.target + " .list-group-item," + this._config.target + " .dropdown-item",
            this._offsets = [],
            this._targets = [],
            this._activeTarget = null,
            this._scrollHeight = 0,
            o.default(this._scrollElement).on("scroll.bs.scrollspy", (function(e) {
                return n._process(e)
            }
            )),
            this.refresh(),
            this._process()
        }
        var t = e.prototype;
        return t.refresh = function() {
            var e = this
              , t = this._scrollElement === this._scrollElement.window ? "offset" : "position"
              , n = "auto" === this._config.method ? t : this._config.method
              , i = "position" === n ? this._getScrollTop() : 0;
            this._offsets = [],
            this._targets = [],
            this._scrollHeight = this._getScrollHeight(),
            [].slice.call(document.querySelectorAll(this._selector)).map((function(e) {
                var t, r = u.getSelectorFromElement(e);
                if (r && (t = document.querySelector(r)),
                t) {
                    var a = t.getBoundingClientRect();
                    if (a.width || a.height)
                        return [o.default(t)[n]().top + i, r]
                }
                return null
            }
            )).filter((function(e) {
                return e
            }
            )).sort((function(e, t) {
                return e[0] - t[0]
            }
            )).forEach((function(t) {
                e._offsets.push(t[0]),
                e._targets.push(t[1])
            }
            ))
        }
        ,
        t.dispose = function() {
            o.default.removeData(this._element, "bs.scrollspy"),
            o.default(this._scrollElement).off(".bs.scrollspy"),
            this._element = null,
            this._scrollElement = null,
            this._config = null,
            this._selector = null,
            this._offsets = null,
            this._targets = null,
            this._activeTarget = null,
            this._scrollHeight = null
        }
        ,
        t._getConfig = function(e) {
            if ("string" != typeof (e = l({}, oe, "object" == typeof e && e ? e : {})).target && u.isElement(e.target)) {
                var t = o.default(e.target).attr("id");
                t || (t = u.getUID(ne),
                o.default(e.target).attr("id", t)),
                e.target = "#" + t
            }
            return u.typeCheckConfig(ne, e, re),
            e
        }
        ,
        t._getScrollTop = function() {
            return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop
        }
        ,
        t._getScrollHeight = function() {
            return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
        }
        ,
        t._getOffsetHeight = function() {
            return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height
        }
        ,
        t._process = function() {
            var e = this._getScrollTop() + this._config.offset
              , t = this._getScrollHeight()
              , n = this._config.offset + t - this._getOffsetHeight();
            if (this._scrollHeight !== t && this.refresh(),
            e >= n) {
                var i = this._targets[this._targets.length - 1];
                this._activeTarget !== i && this._activate(i)
            } else {
                if (this._activeTarget && e < this._offsets[0] && this._offsets[0] > 0)
                    return this._activeTarget = null,
                    void this._clear();
                for (var o = this._offsets.length; o--; )
                    this._activeTarget !== this._targets[o] && e >= this._offsets[o] && (void 0 === this._offsets[o + 1] || e < this._offsets[o + 1]) && this._activate(this._targets[o])
            }
        }
        ,
        t._activate = function(e) {
            this._activeTarget = e,
            this._clear();
            var t = this._selector.split(",").map((function(t) {
                return t + '[data-target="' + e + '"],' + t + '[href="' + e + '"]'
            }
            ))
              , n = o.default([].slice.call(document.querySelectorAll(t.join(","))));
            n.hasClass("dropdown-item") ? (n.closest(".dropdown").find(".dropdown-toggle").addClass("active"),
            n.addClass("active")) : (n.addClass("active"),
            n.parents(".nav, .list-group").prev(".nav-link, .list-group-item").addClass("active"),
            n.parents(".nav, .list-group").prev(".nav-item").children(".nav-link").addClass("active")),
            o.default(this._scrollElement).trigger("activate.bs.scrollspy", {
                relatedTarget: e
            })
        }
        ,
        t._clear = function() {
            [].slice.call(document.querySelectorAll(this._selector)).filter((function(e) {
                return e.classList.contains("active")
            }
            )).forEach((function(e) {
                return e.classList.remove("active")
            }
            ))
        }
        ,
        e._jQueryInterface = function(t) {
            return this.each((function() {
                var n = o.default(this).data("bs.scrollspy");
                if (n || (n = new e(this,"object" == typeof t && t),
                o.default(this).data("bs.scrollspy", n)),
                "string" == typeof t) {
                    if (void 0 === n[t])
                        throw new TypeError('No method named "' + t + '"');
                    n[t]()
                }
            }
            ))
        }
        ,
        s(e, null, [{
            key: "VERSION",
            get: function() {
                return "4.5.3"
            }
        }, {
            key: "Default",
            get: function() {
                return oe
            }
        }]),
        e
    }();
    o.default(window).on("load.bs.scrollspy.data-api", (function() {
        for (var e = [].slice.call(document.querySelectorAll('[data-spy="scroll"]')), t = e.length; t--; ) {
            var n = o.default(e[t]);
            ae._jQueryInterface.call(n, n.data())
        }
    }
    )),
    o.default.fn[ne] = ae._jQueryInterface,
    o.default.fn[ne].Constructor = ae,
    o.default.fn[ne].noConflict = function() {
        return o.default.fn[ne] = ie,
        ae._jQueryInterface
    }
    ;
    var se = o.default.fn.tab
      , le = function() {
        function e(e) {
            this._element = e
        }
        var t = e.prototype;
        return t.show = function() {
            var e = this;
            if (!(this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && o.default(this._element).hasClass("active") || o.default(this._element).hasClass("disabled"))) {
                var t, n, i = o.default(this._element).closest(".nav, .list-group")[0], r = u.getSelectorFromElement(this._element);
                if (i) {
                    var a = "UL" === i.nodeName || "OL" === i.nodeName ? "> li > .active" : ".active";
                    n = (n = o.default.makeArray(o.default(i).find(a)))[n.length - 1]
                }
                var s = o.default.Event("hide.bs.tab", {
                    relatedTarget: this._element
                })
                  , l = o.default.Event("show.bs.tab", {
                    relatedTarget: n
                });
                if (n && o.default(n).trigger(s),
                o.default(this._element).trigger(l),
                !l.isDefaultPrevented() && !s.isDefaultPrevented()) {
                    r && (t = document.querySelector(r)),
                    this._activate(this._element, i);
                    var d = function() {
                        var t = o.default.Event("hidden.bs.tab", {
                            relatedTarget: e._element
                        })
                          , i = o.default.Event("shown.bs.tab", {
                            relatedTarget: n
                        });
                        o.default(n).trigger(t),
                        o.default(e._element).trigger(i)
                    };
                    t ? this._activate(t, t.parentNode, d) : d()
                }
            }
        }
        ,
        t.dispose = function() {
            o.default.removeData(this._element, "bs.tab"),
            this._element = null
        }
        ,
        t._activate = function(e, t, n) {
            var i = this
              , r = (!t || "UL" !== t.nodeName && "OL" !== t.nodeName ? o.default(t).children(".active") : o.default(t).find("> li > .active"))[0]
              , a = n && r && o.default(r).hasClass("fade")
              , s = function() {
                return i._transitionComplete(e, r, n)
            };
            if (r && a) {
                var l = u.getTransitionDurationFromElement(r);
                o.default(r).removeClass("show").one(u.TRANSITION_END, s).emulateTransitionEnd(l)
            } else
                s()
        }
        ,
        t._transitionComplete = function(e, t, n) {
            if (t) {
                o.default(t).removeClass("active");
                var i = o.default(t.parentNode).find("> .dropdown-menu .active")[0];
                i && o.default(i).removeClass("active"),
                "tab" === t.getAttribute("role") && t.setAttribute("aria-selected", !1)
            }
            if (o.default(e).addClass("active"),
            "tab" === e.getAttribute("role") && e.setAttribute("aria-selected", !0),
            u.reflow(e),
            e.classList.contains("fade") && e.classList.add("show"),
            e.parentNode && o.default(e.parentNode).hasClass("dropdown-menu")) {
                var r = o.default(e).closest(".dropdown")[0];
                if (r) {
                    var a = [].slice.call(r.querySelectorAll(".dropdown-toggle"));
                    o.default(a).addClass("active")
                }
                e.setAttribute("aria-expanded", !0)
            }
            n && n()
        }
        ,
        e._jQueryInterface = function(t) {
            return this.each((function() {
                var n = o.default(this)
                  , i = n.data("bs.tab");
                if (i || (i = new e(this),
                n.data("bs.tab", i)),
                "string" == typeof t) {
                    if (void 0 === i[t])
                        throw new TypeError('No method named "' + t + '"');
                    i[t]()
                }
            }
            ))
        }
        ,
        s(e, null, [{
            key: "VERSION",
            get: function() {
                return "4.5.3"
            }
        }]),
        e
    }();
    o.default(document).on("click.bs.tab.data-api", '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]', (function(e) {
        e.preventDefault(),
        le._jQueryInterface.call(o.default(this), "show")
    }
    )),
    o.default.fn.tab = le._jQueryInterface,
    o.default.fn.tab.Constructor = le,
    o.default.fn.tab.noConflict = function() {
        return o.default.fn.tab = se,
        le._jQueryInterface
    }
    ;
    var ue = o.default.fn.toast
      , de = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    }
      , ce = {
        animation: !0,
        autohide: !0,
        delay: 500
    }
      , fe = function() {
        function e(e, t) {
            this._element = e,
            this._config = this._getConfig(t),
            this._timeout = null,
            this._setListeners()
        }
        var t = e.prototype;
        return t.show = function() {
            var e = this
              , t = o.default.Event("show.bs.toast");
            if (o.default(this._element).trigger(t),
            !t.isDefaultPrevented()) {
                this._clearTimeout(),
                this._config.animation && this._element.classList.add("fade");
                var n = function() {
                    e._element.classList.remove("showing"),
                    e._element.classList.add("show"),
                    o.default(e._element).trigger("shown.bs.toast"),
                    e._config.autohide && (e._timeout = setTimeout((function() {
                        e.hide()
                    }
                    ), e._config.delay))
                };
                if (this._element.classList.remove("hide"),
                u.reflow(this._element),
                this._element.classList.add("showing"),
                this._config.animation) {
                    var i = u.getTransitionDurationFromElement(this._element);
                    o.default(this._element).one(u.TRANSITION_END, n).emulateTransitionEnd(i)
                } else
                    n()
            }
        }
        ,
        t.hide = function() {
            if (this._element.classList.contains("show")) {
                var e = o.default.Event("hide.bs.toast");
                o.default(this._element).trigger(e),
                e.isDefaultPrevented() || this._close()
            }
        }
        ,
        t.dispose = function() {
            this._clearTimeout(),
            this._element.classList.contains("show") && this._element.classList.remove("show"),
            o.default(this._element).off("click.dismiss.bs.toast"),
            o.default.removeData(this._element, "bs.toast"),
            this._element = null,
            this._config = null
        }
        ,
        t._getConfig = function(e) {
            return e = l({}, ce, o.default(this._element).data(), "object" == typeof e && e ? e : {}),
            u.typeCheckConfig("toast", e, this.constructor.DefaultType),
            e
        }
        ,
        t._setListeners = function() {
            var e = this;
            o.default(this._element).on("click.dismiss.bs.toast", '[data-dismiss="toast"]', (function() {
                return e.hide()
            }
            ))
        }
        ,
        t._close = function() {
            var e = this
              , t = function() {
                e._element.classList.add("hide"),
                o.default(e._element).trigger("hidden.bs.toast")
            };
            if (this._element.classList.remove("show"),
            this._config.animation) {
                var n = u.getTransitionDurationFromElement(this._element);
                o.default(this._element).one(u.TRANSITION_END, t).emulateTransitionEnd(n)
            } else
                t()
        }
        ,
        t._clearTimeout = function() {
            clearTimeout(this._timeout),
            this._timeout = null
        }
        ,
        e._jQueryInterface = function(t) {
            return this.each((function() {
                var n = o.default(this)
                  , i = n.data("bs.toast");
                if (i || (i = new e(this,"object" == typeof t && t),
                n.data("bs.toast", i)),
                "string" == typeof t) {
                    if (void 0 === i[t])
                        throw new TypeError('No method named "' + t + '"');
                    i[t](this)
                }
            }
            ))
        }
        ,
        s(e, null, [{
            key: "VERSION",
            get: function() {
                return "4.5.3"
            }
        }, {
            key: "DefaultType",
            get: function() {
                return de
            }
        }, {
            key: "Default",
            get: function() {
                return ce
            }
        }]),
        e
    }();
    o.default.fn.toast = fe._jQueryInterface,
    o.default.fn.toast.Constructor = fe,
    o.default.fn.toast.noConflict = function() {
        return o.default.fn.toast = ue,
        fe._jQueryInterface
    }
    ,
    e.Alert = f,
    e.Button = p,
    e.Carousel = y,
    e.Collapse = C,
    e.Dropdown = x,
    e.Modal = H,
    e.Popover = te,
    e.Scrollspy = ae,
    e.Tab = le,
    e.Toast = fe,
    e.Tooltip = X,
    e.Util = u,
    Object.defineProperty(e, "__esModule", {
        value: !0
    })
}
)),
function(e, t) {
    "use strict";
    var n = e.History = e.History || {}
      , i = e.jQuery;
    if (void 0 !== n.Adapter)
        throw new Error("History.js Adapter has already been loaded...");
    n.Adapter = {
        bind: function(e, t, n) {
            i(e).bind(t, n)
        },
        trigger: function(e, t, n) {
            i(e).trigger(t, n)
        },
        extractEventData: function(e, t, n) {
            return t && t.originalEvent && t.originalEvent[e] || n && n[e] || void 0
        },
        onDomLoad: function(e) {
            i(e)
        }
    },
    void 0 !== n.init && n.init()
}(window),
/**
* History.js Core
* @author Benjamin Arthur Lupton <contact@balupton.com>
* @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
* @license New BSD License <http://creativecommons.org/licenses/BSD/>
*/
function(e, t) {
    "use strict";
    var n = e.console || t
      , i = e.document
      , o = e.navigator
      , r = !1
      , a = e.setTimeout
      , s = e.clearTimeout
      , l = e.setInterval
      , u = e.clearInterval
      , d = e.JSON
      , c = e.alert
      , f = e.History = e.History || {}
      , h = e.history;
    try {
        (r = e.sessionStorage).setItem("TEST", "1"),
        r.removeItem("TEST")
    } catch (e) {
        r = !1
    }
    if (d.stringify = d.stringify || d.encode,
    d.parse = d.parse || d.decode,
    void 0 !== f.init)
        throw new Error("History.js Core has already been loaded...");
    f.init = function(e) {
        return void 0 !== f.Adapter && (void 0 !== f.initCore && f.initCore(),
        void 0 !== f.initHtml4 && f.initHtml4(),
        !0)
    }
    ,
    f.initCore = function(p) {
        if (void 0 !== f.initCore.initialized)
            return !1;
        if (f.initCore.initialized = !0,
        f.options = f.options || {},
        f.options.hashChangeInterval = f.options.hashChangeInterval || 100,
        f.options.safariPollInterval = f.options.safariPollInterval || 500,
        f.options.doubleCheckInterval = f.options.doubleCheckInterval || 500,
        f.options.disableSuid = f.options.disableSuid || !1,
        f.options.storeInterval = f.options.storeInterval || 1e3,
        f.options.busyDelay = f.options.busyDelay || 250,
        f.options.debug = f.options.debug || !1,
        f.options.initialTitle = f.options.initialTitle || i.title,
        f.options.html4Mode = f.options.html4Mode || !1,
        f.options.delayInit = f.options.delayInit || !1,
        f.intervalList = [],
        f.clearAllIntervals = function() {
            var e, t = f.intervalList;
            if (null != t) {
                for (e = 0; e < t.length; e++)
                    u(t[e]);
                f.intervalList = null
            }
        }
        ,
        f.debug = function() {
            f.options.debug && f.log.apply(f, arguments)
        }
        ,
        f.log = function() {
            var e, t, o, r, a, s = !(void 0 === n || void 0 === n.log || void 0 === n.log.apply), l = i.getElementById("log");
            for (s ? (e = (r = Array.prototype.slice.call(arguments)).shift(),
            void 0 !== n.debug ? n.debug.apply(n, [e, r]) : n.log.apply(n, [e, r])) : e = "\n" + arguments[0] + "\n",
            t = 1,
            o = arguments.length; t < o; ++t) {
                if ("object" == typeof (a = arguments[t]) && void 0 !== d)
                    try {
                        a = d.stringify(a)
                    } catch (e) {}
                e += "\n" + a + "\n"
            }
            return l ? (l.value += e + "\n-----\n",
            l.scrollTop = l.scrollHeight - l.clientHeight) : s || c(e),
            !0
            /**
       * History.getInternetExplorerMajorVersion()
       * Get's the major version of Internet Explorer
       * @return {integer}
       * @license Public Domain
       * @author Benjamin Arthur Lupton <contact@balupton.com>
       * @author James Padolsey <https://gist.github.com/527683>
       */
        }
        ,
        f.getInternetExplorerMajorVersion = function() {
            return f.getInternetExplorerMajorVersion.cached = void 0 !== f.getInternetExplorerMajorVersion.cached ? f.getInternetExplorerMajorVersion.cached : function() {
                for (var e = 3, t = i.createElement("div"), n = t.getElementsByTagName("i"); (t.innerHTML = "\x3c!--[if gt IE " + ++e + "]><i></i><![endif]--\x3e") && n[0]; )
                    ;
                return e > 4 && e
            }()
        }
        ,
        /**
       * History.isInternetExplorer()
       * Are we using Internet Explorer?
       * @return {boolean}
       * @license Public Domain
       * @author Benjamin Arthur Lupton <contact@balupton.com>
       */
        f.isInternetExplorer = function() {
            return f.isInternetExplorer.cached = void 0 !== f.isInternetExplorer.cached ? f.isInternetExplorer.cached : Boolean(f.getInternetExplorerMajorVersion())
        }
        ,
        f.options.html4Mode ? f.emulated = {
            pushState: !0,
            hashChange: !0
        } : f.emulated = {
            pushState: !Boolean(e.history && e.history.pushState && e.history.replaceState && !(/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(o.userAgent) || /AppleWebKit\/5([0-2]|3[0-2])/i.test(o.userAgent))),
            hashChange: Boolean(!("onhashchange"in e || "onhashchange"in i) || f.isInternetExplorer() && f.getInternetExplorerMajorVersion() < 8)
        },
        f.enabled = !f.emulated.pushState,
        f.bugs = {
            setHash: Boolean(!f.emulated.pushState && "Apple Computer, Inc." === o.vendor && /AppleWebKit\/5([0-2]|3[0-3])/.test(o.userAgent)),
            safariPoll: Boolean(!f.emulated.pushState && "Apple Computer, Inc." === o.vendor && /AppleWebKit\/5([0-2]|3[0-3])/.test(o.userAgent)),
            ieDoubleCheck: Boolean(f.isInternetExplorer() && f.getInternetExplorerMajorVersion() < 8),
            hashEscape: Boolean(f.isInternetExplorer() && f.getInternetExplorerMajorVersion() < 7)
        },
        f.isEmptyObject = function(e) {
            for (var t in e)
                if (e.hasOwnProperty(t))
                    return !1;
            return !0
        }
        ,
        f.cloneObject = function(e) {
            var t, n;
            return e ? (t = d.stringify(e),
            n = d.parse(t)) : n = {},
            n
        }
        ,
        f.getRootUrl = function() {
            var e = i.location.protocol + "//" + (i.location.hostname || i.location.host);
            return i.location.port && (e += ":" + i.location.port),
            e + "/"
        }
        ,
        f.getBaseHref = function() {
            var e = i.getElementsByTagName("base")
              , t = "";
            return 1 === e.length && (t = e[0].href.replace(/[^\/]+$/, "")),
            (t = t.replace(/\/+$/, "")) && (t += "/"),
            t
        }
        ,
        f.getBaseUrl = function() {
            return f.getBaseHref() || f.getBasePageUrl() || f.getRootUrl()
        }
        ,
        f.getPageUrl = function() {
            return ((f.getState(!1, !1) || {}).url || f.getLocationHref()).replace(/\/+$/, "").replace(/[^\/]+$/, (function(e, t, n) {
                return /\./.test(e) ? e : e + "/"
            }
            ))
        }
        ,
        f.getBasePageUrl = function() {
            return f.getLocationHref().replace(/[#\?].*/, "").replace(/[^\/]+$/, (function(e, t, n) {
                return /[^\/]$/.test(e) ? "" : e
            }
            )).replace(/\/+$/, "") + "/"
        }
        ,
        f.getFullUrl = function(e, t) {
            var n = e
              , i = e.substring(0, 1);
            return t = void 0 === t || t,
            /[a-z]+\:\/\//.test(e) || (n = "/" === i ? f.getRootUrl() + e.replace(/^\/+/, "") : "#" === i ? f.getPageUrl().replace(/#.*/, "") + e : "?" === i ? f.getPageUrl().replace(/[\?#].*/, "") + e : t ? f.getBaseUrl() + e.replace(/^(\.\/)+/, "") : f.getBasePageUrl() + e.replace(/^(\.\/)+/, "")),
            n.replace(/\#$/, "")
        }
        ,
        f.getShortUrl = function(e) {
            var t = e
              , n = f.getBaseUrl()
              , i = f.getRootUrl();
            return f.emulated.pushState && (t = t.replace(n, "")),
            t = t.replace(i, "/"),
            f.isTraditionalAnchor(t) && (t = "./" + t),
            t.replace(/^(\.\/)+/g, "./").replace(/\#$/, "")
        }
        ,
        f.getLocationHref = function(e) {
            return (e = e || i).URL === e.location.href ? e.location.href : e.location.href === decodeURIComponent(e.URL) ? e.URL : e.location.hash && decodeURIComponent(e.location.href.replace(/^[^#]+/, "")) === e.location.hash || -1 == e.URL.indexOf("#") && -1 != e.location.href.indexOf("#") ? e.location.href : e.URL || e.location.href
        }
        ,
        f.store = {},
        f.idToState = f.idToState || {},
        f.stateToId = f.stateToId || {},
        f.urlToId = f.urlToId || {},
        f.storedStates = f.storedStates || [],
        f.savedStates = f.savedStates || [],
        f.normalizeStore = function() {
            f.store.idToState = f.store.idToState || {},
            f.store.urlToId = f.store.urlToId || {},
            f.store.stateToId = f.store.stateToId || {}
        }
        ,
        f.getState = function(e, t) {
            void 0 === e && (e = !0),
            void 0 === t && (t = !0);
            var n = f.getLastSavedState();
            return !n && t && (n = f.createStateObject()),
            e && ((n = f.cloneObject(n)).url = n.cleanUrl || n.url),
            n
        }
        ,
        f.getIdByState = function(e) {
            var t, n = f.extractId(e.url);
            if (!n)
                if (t = f.getStateString(e),
                void 0 !== f.stateToId[t])
                    n = f.stateToId[t];
                else if (void 0 !== f.store.stateToId[t])
                    n = f.store.stateToId[t];
                else {
                    for (; n = (new Date).getTime() + String(Math.random()).replace(/\D/g, ""),
                    void 0 !== f.idToState[n] || void 0 !== f.store.idToState[n]; )
                        ;
                    f.stateToId[t] = n,
                    f.idToState[n] = e
                }
            return n
        }
        ,
        f.normalizeState = function(e) {
            var t, n;
            return e && "object" == typeof e || (e = {}),
            void 0 !== e.normalized ? e : (e.data && "object" == typeof e.data || (e.data = {}),
            (t = {}).normalized = !0,
            t.title = e.title || "",
            t.url = f.getFullUrl(e.url ? e.url : f.getLocationHref()),
            t.hash = f.getShortUrl(t.url),
            t.data = f.cloneObject(e.data),
            t.id = f.getIdByState(t),
            t.cleanUrl = t.url.replace(/\??\&_suid.*/, ""),
            t.url = t.cleanUrl,
            n = !f.isEmptyObject(t.data),
            (t.title || n) && !0 !== f.options.disableSuid && (t.hash = f.getShortUrl(t.url).replace(/\??\&_suid.*/, ""),
            /\?/.test(t.hash) || (t.hash += "?"),
            t.hash += "&_suid=" + t.id),
            t.hashedUrl = f.getFullUrl(t.hash),
            (f.emulated.pushState || f.bugs.safariPoll) && f.hasUrlDuplicate(t) && (t.url = t.hashedUrl),
            t)
        }
        ,
        f.createStateObject = function(e, t, n) {
            var i = {
                data: e,
                title: t,
                url: n
            };
            return f.normalizeState(i)
        }
        ,
        f.getStateById = function(e) {
            return e = String(e),
            f.idToState[e] || f.store.idToState[e] || t
        }
        ,
        f.getStateString = function(e) {
            var t;
            return t = {
                data: f.normalizeState(e).data,
                title: e.title,
                url: e.url
            },
            d.stringify(t)
        }
        ,
        f.getStateId = function(e) {
            return f.normalizeState(e).id
        }
        ,
        f.getHashByState = function(e) {
            return f.normalizeState(e).hash
        }
        ,
        f.extractId = function(e) {
            var t, n;
            return n = -1 != e.indexOf("#") ? e.split("#")[0] : e,
            (t = /(.*)\&_suid=([0-9]+)$/.exec(n)) && t[1],
            (t ? String(t[2] || "") : "") || !1
        }
        ,
        f.isTraditionalAnchor = function(e) {
            return !/[\/\?\.]/.test(e)
        }
        ,
        f.extractState = function(e, t) {
            var n, i, o = null;
            return t = t || !1,
            (n = f.extractId(e)) && (o = f.getStateById(n)),
            o || (i = f.getFullUrl(e),
            (n = f.getIdByUrl(i) || !1) && (o = f.getStateById(n)),
            o || !t || f.isTraditionalAnchor(e) || (o = f.createStateObject(null, null, i))),
            o
        }
        ,
        f.getIdByUrl = function(e) {
            return f.urlToId[e] || f.store.urlToId[e] || t
        }
        ,
        f.getLastSavedState = function() {
            return f.savedStates[f.savedStates.length - 1] || t
        }
        ,
        f.getLastStoredState = function() {
            return f.storedStates[f.storedStates.length - 1] || t
        }
        ,
        f.hasUrlDuplicate = function(e) {
            var t;
            return (t = f.extractState(e.url)) && t.id !== e.id
        }
        ,
        f.storeState = function(e) {
            return f.urlToId[e.url] = e.id,
            f.storedStates.push(f.cloneObject(e)),
            e
        }
        ,
        f.isLastSavedState = function(e) {
            var t = !1;
            return f.savedStates.length && (t = e.id === f.getLastSavedState().id),
            t
        }
        ,
        f.saveState = function(e) {
            return !f.isLastSavedState(e) && (f.savedStates.push(f.cloneObject(e)),
            !0)
        }
        ,
        f.getStateByIndex = function(e) {
            return void 0 === e ? f.savedStates[f.savedStates.length - 1] : e < 0 ? f.savedStates[f.savedStates.length + e] : f.savedStates[e]
        }
        ,
        f.getCurrentIndex = function() {
            return f.savedStates.length < 1 ? 0 : f.savedStates.length - 1
        }
        ,
        f.getHash = function(e) {
            var t = f.getLocationHref(e);
            return f.getHashByUrl(t)
        }
        ,
        f.unescapeHash = function(e) {
            var t = f.normalizeHash(e);
            return decodeURIComponent(t)
        }
        ,
        f.normalizeHash = function(e) {
            return e.replace(/[^#]*#/, "").replace(/#.*/, "")
        }
        ,
        f.setHash = function(e, t) {
            var n, o;
            return !1 !== t && f.busy() ? (f.pushQueue({
                scope: f,
                callback: f.setHash,
                args: arguments,
                queue: t
            }),
            !1) : (f.busy(!0),
            (n = f.extractState(e, !0)) && !f.emulated.pushState ? f.pushState(n.data, n.title, n.url, !1) : f.getHash() !== e && (f.bugs.setHash ? (o = f.getPageUrl(),
            f.pushState(null, null, o + "#" + e, !1)) : i.location.hash = e),
            f)
        }
        ,
        f.escapeHash = function(t) {
            var n = f.normalizeHash(t);
            return n = e.encodeURIComponent(n),
            f.bugs.hashEscape || (n = n.replace(/\%21/g, "!").replace(/\%26/g, "&").replace(/\%3D/g, "=").replace(/\%3F/g, "?")),
            n
        }
        ,
        f.getHashByUrl = function(e) {
            var t = String(e).replace(/([^#]*)#?([^#]*)#?(.*)/, "$2");
            return f.unescapeHash(t)
        }
        ,
        f.setTitle = function(e) {
            var t, n = e.title;
            n || (t = f.getStateByIndex(0)) && t.url === e.url && (n = t.title || f.options.initialTitle);
            try {
                i.getElementsByTagName("title")[0].innerHTML = n.replace("<", "&lt;").replace(">", "&gt;").replace(" & ", " &amp; ")
            } catch (e) {}
            return i.title = n,
            f
        }
        ,
        f.queues = [],
        f.busy = function(e) {
            if (void 0 !== e ? f.busy.flag = e : void 0 === f.busy.flag && (f.busy.flag = !1),
            !f.busy.flag) {
                s(f.busy.timeout);
                var t = function() {
                    var e, n, i;
                    if (!f.busy.flag)
                        for (e = f.queues.length - 1; e >= 0; --e)
                            0 !== (n = f.queues[e]).length && (i = n.shift(),
                            f.fireQueueItem(i),
                            f.busy.timeout = a(t, f.options.busyDelay))
                };
                f.busy.timeout = a(t, f.options.busyDelay)
            }
            return f.busy.flag
        }
        ,
        f.busy.flag = !1,
        f.fireQueueItem = function(e) {
            return e.callback.apply(e.scope || f, e.args || [])
        }
        ,
        f.pushQueue = function(e) {
            return f.queues[e.queue || 0] = f.queues[e.queue || 0] || [],
            f.queues[e.queue || 0].push(e),
            f
        }
        ,
        f.queue = function(e, t) {
            return "function" == typeof e && (e = {
                callback: e
            }),
            void 0 !== t && (e.queue = t),
            f.busy() ? f.pushQueue(e) : f.fireQueueItem(e),
            f
        }
        ,
        f.clearQueue = function() {
            return f.busy.flag = !1,
            f.queues = [],
            f
        }
        ,
        f.stateChanged = !1,
        f.doubleChecker = !1,
        f.doubleCheckComplete = function() {
            return f.stateChanged = !0,
            f.doubleCheckClear(),
            f
        }
        ,
        f.doubleCheckClear = function() {
            return f.doubleChecker && (s(f.doubleChecker),
            f.doubleChecker = !1),
            f
        }
        ,
        f.doubleCheck = function(e) {
            return f.stateChanged = !1,
            f.doubleCheckClear(),
            f.bugs.ieDoubleCheck && (f.doubleChecker = a((function() {
                return f.doubleCheckClear(),
                f.stateChanged || e(),
                !0
            }
            ), f.options.doubleCheckInterval)),
            f
        }
        ,
        f.safariStatePoll = function() {
            var t = f.extractState(f.getLocationHref());
            if (!f.isLastSavedState(t))
                return t || f.createStateObject(),
                f.Adapter.trigger(e, "popstate"),
                f
        }
        ,
        f.back = function(e) {
            return !1 !== e && f.busy() ? (f.pushQueue({
                scope: f,
                callback: f.back,
                args: arguments,
                queue: e
            }),
            !1) : (f.busy(!0),
            f.doubleCheck((function() {
                f.back(!1)
            }
            )),
            h.go(-1),
            !0)
        }
        ,
        f.forward = function(e) {
            return !1 !== e && f.busy() ? (f.pushQueue({
                scope: f,
                callback: f.forward,
                args: arguments,
                queue: e
            }),
            !1) : (f.busy(!0),
            f.doubleCheck((function() {
                f.forward(!1)
            }
            )),
            h.go(1),
            !0)
        }
        ,
        f.go = function(e, t) {
            var n;
            if (e > 0)
                for (n = 1; n <= e; ++n)
                    f.forward(t);
            else {
                if (!(e < 0))
                    throw new Error("History.go: History.go requires a positive or negative integer passed.");
                for (n = -1; n >= e; --n)
                    f.back(t)
            }
            return f
        }
        ,
        f.emulated.pushState) {
            var g = function() {};
            f.pushState = f.pushState || g,
            f.replaceState = f.replaceState || g
        } else
            f.onPopState = function(t, n) {
                var i, o, r, a = !1;
                return f.doubleCheckComplete(),
                (o = f.getHash()) ? ((r = f.extractState(o || f.getLocationHref(), !0)) ? f.replaceState(r.data, r.title, r.url, !1) : (f.Adapter.trigger(e, "anchorchange"),
                f.busy(!1)),
                f.expectedStateId = !1,
                !1) : ((a = (i = f.Adapter.extractEventData("state", t, n) || !1) ? f.getStateById(i) : f.expectedStateId ? f.getStateById(f.expectedStateId) : f.extractState(f.getLocationHref())) || (a = f.createStateObject(null, null, f.getLocationHref())),
                f.expectedStateId = !1,
                f.isLastSavedState(a) ? (f.busy(!1),
                !1) : (f.storeState(a),
                f.saveState(a),
                f.setTitle(a),
                f.Adapter.trigger(e, "statechange"),
                f.busy(!1),
                !0))
            }
            ,
            f.Adapter.bind(e, "popstate", f.onPopState),
            f.pushState = function(t, n, i, o) {
                if (f.getHashByUrl(i) && f.emulated.pushState)
                    throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
                if (!1 !== o && f.busy())
                    return f.pushQueue({
                        scope: f,
                        callback: f.pushState,
                        args: arguments,
                        queue: o
                    }),
                    !1;
                f.busy(!0);
                var r = f.createStateObject(t, n, i);
                return f.isLastSavedState(r) ? f.busy(!1) : (f.storeState(r),
                f.expectedStateId = r.id,
                h.pushState(r.id, r.title, r.url),
                f.Adapter.trigger(e, "popstate")),
                !0
            }
            ,
            f.replaceState = function(t, n, i, o) {
                if (f.getHashByUrl(i) && f.emulated.pushState)
                    throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
                if (!1 !== o && f.busy())
                    return f.pushQueue({
                        scope: f,
                        callback: f.replaceState,
                        args: arguments,
                        queue: o
                    }),
                    !1;
                f.busy(!0);
                var r = f.createStateObject(t, n, i);
                return f.isLastSavedState(r) ? f.busy(!1) : (f.storeState(r),
                f.expectedStateId = r.id,
                h.replaceState(r.id, r.title, r.url),
                f.Adapter.trigger(e, "popstate")),
                !0
            }
            ;
        if (r) {
            try {
                f.store = d.parse(r.getItem("History.store")) || {}
            } catch (e) {
                f.store = {}
            }
            f.normalizeStore()
        } else
            f.store = {},
            f.normalizeStore();
        f.Adapter.bind(e, "unload", f.clearAllIntervals),
        f.saveState(f.storeState(f.extractState(f.getLocationHref(), !0))),
        r && (f.onUnload = function() {
            var e, t, n;
            try {
                e = d.parse(r.getItem("History.store")) || {}
            } catch (t) {
                e = {}
            }
            for (t in e.idToState = e.idToState || {},
            e.urlToId = e.urlToId || {},
            e.stateToId = e.stateToId || {},
            f.idToState)
                f.idToState.hasOwnProperty(t) && (e.idToState[t] = f.idToState[t]);
            for (t in f.urlToId)
                f.urlToId.hasOwnProperty(t) && (e.urlToId[t] = f.urlToId[t]);
            for (t in f.stateToId)
                f.stateToId.hasOwnProperty(t) && (e.stateToId[t] = f.stateToId[t]);
            f.store = e,
            f.normalizeStore(),
            n = d.stringify(e);
            try {
                r.setItem("History.store", n)
            } catch (e) {
                if (e.code !== DOMException.QUOTA_EXCEEDED_ERR)
                    throw e;
                r.length && (r.removeItem("History.store"),
                r.setItem("History.store", n))
            }
        }
        ,
        f.intervalList.push(l(f.onUnload, f.options.storeInterval)),
        f.Adapter.bind(e, "beforeunload", f.onUnload),
        f.Adapter.bind(e, "unload", f.onUnload)),
        f.emulated.pushState || (f.bugs.safariPoll && f.intervalList.push(l(f.safariStatePoll, f.options.safariPollInterval)),
        "Apple Computer, Inc." !== o.vendor && "Mozilla" !== (o.appCodeName || "") || (f.Adapter.bind(e, "hashchange", (function() {
            f.Adapter.trigger(e, "popstate")
        }
        )),
        f.getHash() && f.Adapter.onDomLoad((function() {
            f.Adapter.trigger(e, "hashchange")
        }
        ))))
    }
    ,
    f.options && f.options.delayInit || f.init()
}(window),
"object" == typeof Countries && (Countries.updateProvinceLabel = function(e, t) {
    if ("string" == typeof e && Countries[e] && Countries[e].provinces) {
        if ("object" != typeof t && null === (t = document.getElementById("address_province_label")))
            return;
        t.innerHTML = Countries[e].label;
        var n = jQuery(t).parent();
        n.find("select"),
        n.find(".custom-style-select-box-inner").html(Countries[e].provinces[0])
    }
}
),
void 0 === Shopify.Cart && (Shopify.Cart = {}),
Shopify.Cart.ShippingCalculator = function() {
    var _config = {
        submitButton: "Calculate shipping",
        submitButtonDisabled: "Calculating...",
        templateId: "shipping-calculator-response-template",
        wrapperId: "wrapper-response",
        customerIsLoggedIn: !1,
        moneyFormat: "Rs. {{amount}}",
        CalculateMessSuccess: "We found one shipping rate available for",
        CalculateMessPrice: " at ",
        CalculateMessError: "We do not ship to this destination."
    }
      , _render = function(e) {
        var t = "";
        e ? (t += '<div class="shipping_calculate_mess">' + _config.CalculateMessSuccess + " " + e.address + ".</div>",
        e.rates && (t += '<ul class="shipping_calculate_rate">',
        e.rates.forEach((function(e) {
            t += '<li class="shipping_calculate_rate">' + e.presentment_name + " " + _config.CalculateMessPrice + " " + e.price + "</li>"
        }
        )),
        t += "</ul>")) : t += '<div class="shipping_calculate_rate">' + _config.CalculateMessError + "</div>",
        jQuery("#" + _config.wrapperId).html(t)
    }
      , _enableButtons = function() {
        jQuery(".get-rates").removeAttr("disabled").removeClass("disabled").val(_config.submitButton)
    }
      , _disableButtons = function() {
        jQuery(".get-rates").val(_config.submitButtonDisabled).attr("disabled", "disabled").addClass("disabled")
    }
      , _getCartShippingRatesForDestination = function(e) {
        var t = {
            type: "POST",
            url: "/cart/prepare_shipping_rates",
            data: jQuery.param({
                shipping_address: e
            }),
            success: _pollForCartShippingRatesForDestination(e),
            error: _onError
        };
        jQuery.ajax(t)
    }
      , _pollForCartShippingRatesForDestination = function(e) {
        var t = function() {
            jQuery.ajax("/cart/async_shipping_rates", {
                dataType: "json",
                success: function(n, i, o) {
                    200 === o.status ? _onCartShippingRatesUpdate(n.shipping_rates, e) : setTimeout(t, 500)
                },
                error: _onError
            })
        };
        return t
    }
      , _fullMessagesFromErrors = function(e) {
        var t = [];
        return jQuery.each(e, (function(e, n) {
            jQuery.each(n, (function(n, i) {
                t.push(e + " " + i)
            }
            ))
        }
        )),
        t
    }
      , _onError = function(XMLHttpRequest, textStatus) {
        jQuery("#estimated-shipping").hide(),
        jQuery("#estimated-shipping em").empty(),
        _enableButtons();
        var feedback = ""
          , data = eval("(" + XMLHttpRequest.responseText + ")");
        feedback = data.message ? data.message + "(" + data.status + "): " + data.description : "Error : " + _fullMessagesFromErrors(data).join("; ") + ".",
        "Error : country is not supported." === feedback && (feedback = "We do not ship to this destination."),
        _render({
            rates: [],
            errorFeedback: feedback,
            success: !1
        }),
        jQuery("#" + _config.wrapperId).show()
    }
      , _onCartShippingRatesUpdate = function(e, t) {
        _enableButtons();
        var n = "";
        if (t.zip && (n += t.zip + ", "),
        t.province && (n += t.province + ", "),
        n += t.country,
        e.length) {
            "0.00" == e[0].price ? jQuery("#estimated-shipping em").html("FREE") : jQuery("#estimated-shipping em").html(_formatRate(e[0].price));
            for (var i = 0; i < e.length; i++)
                e[i].price = _formatRate(e[i].price)
        }
        _render({
            rates: e,
            address: n,
            success: !0
        }),
        jQuery("#" + _config.wrapperId + ", #estimated-shipping").fadeIn()
    }
      , _formatRate = function(e) {
        function t(e, t) {
            return void 0 === e ? t : e
        }
        function n(e, n, i, o) {
            if (n = t(n, 2),
            i = t(i, ","),
            o = t(o, "."),
            isNaN(e) || null == e)
                return 0;
            var r = (e = (e / 100).toFixed(n)).split(".");
            return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (r[1] ? o + r[1] : "")
        }
        if ("function" == typeof Shopify.formatMoney)
            return Shopify.formatMoney(e, _config.moneyFormat);
        "string" == typeof e && (e = e.replace(".", ""));
        var i = ""
          , o = /\{\{\s*(\w+)\s*\}\}/
          , r = _config.moneyFormat;
        switch (r.match(o)[1]) {
        case "amount":
            i = n(e, 2);
            break;
        case "amount_no_decimals":
            i = n(e, 0);
            break;
        case "amount_with_comma_separator":
            i = n(e, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            i = n(e, 0, ".", ",")
        }
        return r.replace(o, i)
    };
    return _init = function() {
		if (document.getElementById('shipping-calculator')) {
			new Shopify.CountryProvinceSelector("address_country","address_province",{
				hideElement: "address_province_container"
			});
			var e = jQuery("#address_country")
			  , t = jQuery("#address_province_label").get(0);
			"undefined" != typeof Countries && (Countries.updateProvinceLabel(e.val(), t),
			e.change((function() {
				Countries.updateProvinceLabel(e.val(), t)
			}
			))),
			jQuery(".get-rates").click((function() {
				_disableButtons(),
				jQuery("#" + _config.wrapperId).empty().hide();
				var e = {};
				e.zip = jQuery("#address_zip").val() || "",
				e.country = jQuery("#address_country").val() || "",
				e.province = jQuery("#address_province").val() || "",
				_getCartShippingRatesForDestination(e)
			}
			)),
			_config.customerIsLoggedIn && jQuery(".get-rates:eq(0)").trigger("click")
		}
    }
    ,
    {
        show: function(e) {
            e = e || {},
            jQuery.extend(_config, e),
            jQuery((function() {
                _init()
            }
            ))
        },
        getConfig: function() {
            return _config
        },
        formatRate: function(e) {
            return _formatRate(e)
        }
    }
}();
